
import React, { useState, useEffect, useRef } from 'react';
import { BarChart, CartesianGrid, XAxis, YAxis, Tooltip, Legend, Bar, ResponsiveContainer, PieChart, Pie, Cell, } from 'recharts';
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../../config/axios';
import * as XLSX from "xlsx";
import axios from 'axios';
import { customSortByKey, formatRoundoff2D, formatRoundoffCompleteNoComma, handleAllError, handleErrorToast, CustomTooltip, isValidTwoDecimalNumber, inputMinLimit, calculateDaysBetween, calculateDaysFromDateList, generateCustomFileForUpload, getFileNameFromUrl, ButtonVariants, getMonthNameFromDate, getMonthName, getMonthYearNameFromDate } from '../CustomFunctions';
import { AddwithBlueCircle, Attachment, DownloadIcon, Eye, Filter, Office, UpdatePencil, UploadIcon, BlueEye, WarnYellow, AddwithWhiteCircle, CrosswithGreyCircle, CloudUpload, DeleteDustbin, SubmitArrowHead1, InfoIcon, DropdownArrowOption } from '../AllSvg';
import { formattedDate, formattedDateLong } from '../Date';
import usePermission from '../../config/permissions';
import Signature from './Picture 1.png'
import { formatDate, formatDateTime } from '../Date';
import GengLogo from './g-eng.png'
import GengSignature from './g-eng_signature.png'
import AimantraSignature from './AimantraStampVS.png'
import { fetchExistingLetterTemplate } from '../CustomUtilities';
import { ViewLetterBuilder } from '../DynamicBuilders/LetterBuilderManagement/LetterTemplateComponentsTesting';

const Card = ({ number, content, pay, footer, image, svgPath }) => {
  return (
    <div className="summaryCard" >

      <div className="summaryCardd">
        <div>
          <h4 className="summaryCard-number font-size-subheading  ">{number}</h4>
          <p className="summaryCard-text-a">{content}</p>
          <p className="summaryCard-text-b font-size-text ">{pay} Last Month</p>
        </div>
        <div className='summaryCard-button'>
          <button className='summaryCard-buttonn'>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#007bff">
              <path d={svgPath} />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

const SummaryStats = () => {
  const data = [
    { number: "89,935", content: "Statutory Pay", pay: "+3.4", svgPath: "M19,8V7c0-1.1-0.9-2-2-2H7C5.9,5,5,5.9,5,7v1H3v13c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V8H19z M12,18c-1.1,0-2-0.9-2-2 s0.9-2,2-2s2,0.9,2,2S13.1,18,12,18z M17,9H7V7h10V9z M5,20v-2h14v2H5z M7,12c-0.55,0-1-0.45-1-1s0.45-1,1-1s1,0.45,1,1S7.55,12,7,12z M17,12c-0.55,0-1-0.45-1-1s0.45-1,1-1s1,0.45,1,1S17.55,12,17,12z" },
    { number: "23,223.5", content: "Net Salary", pay: "+3.4", svgPath: "M17.2 11h-2.1c-1 0-1.9.4-2.6 1h-.9c-.7-.6-1.7-1-2.7-1H6.8c-1.8 0-3.5 1.2-4 3l-.7 2.6c-.3 1.2.3 2.4 1.4 2.7.6.2 1.2.3 1.9.5.2.8.8 1.4 1.6 1.6 1.6.5 3.3.8 5 .8s3.4-.3 5-.8c.8-.3 1.3-.9 1.5-1.6.7-.1 1.3-.3 1.9-.5.9-.3 1.5-1.2 1.5-2.1 0-.2 0-.5-.1-.6l-.6-2.6c-.5-1.8-2.2-3-4-3zM4 17.1l.7-2.6C5 13.6 5.9 13 6.8 13h1.1c-.1.1-.2.2-.3.2-.1.1-.2.1-.2.2l-.3.3c-.1.2-.1.2-.2.3-.1.1-.2.3-.2.4 0 .1-.1.1-.1.2-.1.2-.2.5-.3.7l-.7 2.4c-.5-.1-.9-.2-1.4-.4-.1 0-.2-.1-.2-.2zm12.4 2.4c-2.9.9-5.9.9-8.8 0-.2-.1-.3-.3-.3-.5l.9-3c.3-1.1 1.4-1.9 2.6-1.9h2.5c1.2 0 2.2.8 2.6 1.9l.9 3v.1c-.1.2-.3.3-.4.4zm3.4-2.1c-.5.2-1 .3-1.4.4l-.7-2.4c-.1-.2-.2-.5-.3-.7 0-.1-.1-.1-.1-.2-.1-.1-.2-.3-.2-.4-.1-.1-.1-.2-.2-.2l-.3-.3c-.1-.1-.2-.1-.2-.2-.1-.1-.2-.2-.3-.2h1.1c.9 0 1.8.6 2 1.5l.7 2.6c.1 0 .1.1-.1.1zM16 3.9c-.4 0-.8.1-1.2.2C14 3.4 13.1 3 12 3c-1.1 0-2.1.4-2.8 1.2-.4-.2-.8-.3-1.2-.3-.9 0-1.8.4-2.3 1-.5.6-.8 1.3-.8 2.1 0 .2 0 .5.1.7.3 1.4 1.6 2.4 3 2.4.4 0 .8-.1 1.2-.2.7.7 1.7 1.1 2.8 1.1 1.1 0 2.1-.4 2.8-1.2.4.2.8.2 1.2.2 1.5 0 2.7-1 3-2.4 0-.2.1-.4.1-.7 0-.8-.3-1.5-.8-2-.5-.6-1.4-1-2.3-1zM7 7.3V7c0-.3.1-.5.3-.7.1-.3.4-.4.7-.4h.1c0 .2-.1.3-.1.5V7c0 .3 0 .6.1.9v.2c-.5 0-1-.3-1.1-.8zM12 9c-.7 0-1.4-.4-1.7-1-.1-.2-.2-.3-.2-.5-.1-.2-.1-.4-.1-.5 0-.4.1-.7.3-1 .1-.1.1-.2.2-.3.4-.5.9-.7 1.5-.7s1.1.2 1.5.7c.1.1.1.2.2.3.2.3.3.6.3 1 0 .1 0 .3-.1.5 0 .2-.1.4-.2.5v.1c-.3.5-1 .9-1.7.9zm5.1-1.8c-.1.5-.7.9-1.2.8v-.2c.1-.2.1-.5.1-.8 0-.4-.1-.7-.1-1.1.4 0 .7.1 1 .4.1.2.2.4.2.7v.2z" },
    { number: "46,827", content: "Deduction", pay: "-0.91%", svgPath: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" },
    { number: "124,854", content: "Payroll Cost", pay: "+1.51%", svgPath: "M20 11H7.41l3.29-3.29L10 6l-6 6 6 6 1.71-1.71L7.41 13H20v-2z" }
  ];
  return (
    <>
      <div className='summaryStats'>
        {data.map((item, index) => (
          <Card
            key={index}
            number={item.number}
            content={item.content}
            pay={item.pay}
            svgPath={item.svgPath}
            footer={<div>{item.name} {item.surname}</div>}
            style={{ maxWidth: '400px', marginBottom: '20px' }}
          />
        ))}
      </div>


    </>
  )
};

const PaymentStatus = () => {
  const [data, setData] = useState({
    employees: 2350,
    payment: 56,
    pending: 56,
    paid: 56,
  });
  const [selectedOption, setSelectedOption] = useState('today');
  useEffect(() => {
    // Example API call
    const fetchData = async () => {
      try {
        const response = await fetch('https://api.example.com/payment-status');
        const result = await response.json();
        setData({
          employees: result.employees,
          payment: result.payment,
          pending: result.pending,
          paid: result.paid,
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);
  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="payment-status">
      <div className="header">
        <div className="title">
          <p className='font-size-text'>Salary Status</p>
          <span style={{ fontSize: "0.75em" }}>{data.employees} Employee</span>
        </div>
        <div className="paymentDashboard-dropdown">
          <select className='paymentDashboard-a font-size-label' onChange={handleChange} value={selectedOption}>
            <option value="today">This Year</option>
            <option value="yesterday">Last Year</option>
          </select>
        </div>
      </div>
      <div className="status-bars">
        <div className="status-bar">
          <div className="fill payment payment-radius" style={{ width: `${data.payment}%` }}></div>
          <div className="fill pending payment-radius-a" style={{ width: `${data.pending}%` }}></div>
          <div className="fill paid payment-radius-b" style={{ width: `${data.paid}%` }}></div>
        </div>
      </div>
      <div className="status-labels">
        <div className="label font-size-label">
          <span className="dot payment"></span> Pending <strong>{data.payment}%</strong>
        </div>
        <div className="label font-size-label">
          <span className="dot pending"></span>Hold<strong>{data.pending}%</strong>
        </div>
        <div className="label font-size-label">
          <span className="dot paid"></span> Paid<strong>{data.paid}%</strong>
        </div>
      </div>
    </div>
  );
};

const CustomLegend = ({ payload }) => (
  <ul className='customLegend' >
    {payload.map((entry, index) => (
      <li className='label font-size-label' key={`item-${index}`} style={{ marginRight: 20, display: 'flex', alignItems: 'center' }}>
        <span className='dot'
          style={{
            backgroundColor: entry.color,
          }}
        />
        <div  >
          {entry.value}
          <strong style={{}}>50%</strong>
        </div>
      </li>
    ))}
  </ul>
);

const PayrollHistory = ({ year, code }) => {
  const [selectedOption, setSelectedOption] = useState('today');
  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const data = [
    { name: 'Jan', NetSalary: 15, Taxes: 35, GrossSalary: 25 },
    { name: 'Feb', NetSalary: 15, Taxes: 35, GrossSalary: 25 },
    { name: 'Mar', NetSalary: 15, Taxes: 35, GrossSalary: 25 },
    { name: 'April', NetSalary: 15, Taxes: 35, GrossSalary: 25 },
    { name: 'May', NetSalary: 15, Taxes: 35, GrossSalary: 25 },
    { name: 'Jun', NetSalary: 15, Taxes: 35, GrossSalary: 25 },
    { name: 'July', NetSalary: 15, Taxes: 35, GrossSalary: 25 },
    { name: 'Aug', NetSalary: 15, Taxes: 35, GrossSalary: 25 },
    { name: 'Sept', NetSalary: 15, Taxes: 35, GrossSalary: 25 },
    { name: 'Oct', NetSalary: 15, Taxes: 35, GrossSalary: 25 },
    { name: 'Nov', NetSalary: 15, Taxes: 35, GrossSalary: 25 },
    { name: 'Dec', NetSalary: 15, Taxes: 35, GrossSalary: 25 }
  ];
  return (
    <div className='payrol-history width-50vw' >
      <div className="header">
        <div className="title">
          <p className='font-size-text'>Payroll History</p>
        </div>
        <div className="paymentDashboard-dropdown">
          <select className='paymentDashboard-a font-size-label' onChange={handleChange} value={selectedOption}>
            <option value="today">Today</option>
            <option value="yesterday">Yesterday</option>
          </select>
        </div>
      </div>
      <div >
        <ResponsiveContainer height={312}>
          <BarChart data={data} margin={{ top: 10, right: 20, bottom: 5, left: 0 }}>
            <CartesianGrid strokeDasharray="10 6" vertical={false} />
            <XAxis dataKey="name" angle={-90} tickMargin={10} tick={{ fontSize: 10 }} />
            <YAxis tickMargin={10} tick={{ fontSize: 10 }} />
            <Tooltip />
            <Legend content={<CustomLegend />} />
            <Bar dataKey="NetSalary" fill="red" barSize={6} radius={7} />
            <Bar dataKey="Taxes" fill="#FFD700" barSize={6} radius={7} />
            <Bar dataKey="GrossSalary" fill="#6495ED" barSize={6} radius={7} />
          </BarChart>
        </ResponsiveContainer>
      </div>

    </div>
  );
};

const BankDetails = () => {
  const data = [
    { name: 'Category A', value: 30 },
    { name: 'Category B', value: 10 },
  ];
  const dataa = [

    { name: 'Category A', value: 10 },
    { name: 'Category B', value: 30 },
  ];
  const dataaa = [
    { name: 'Category A', value: 40 },
    { name: 'Category B', value: 20 },
  ];

  const empCOLOURS = ["#FF747C", "#EFEFEF"];
  const detCOLOURS = ["#F7BA1E", "#EFEFEF"];
  const pendingCOLORS = ["#06AD06", "#EFEFEF"];

  return (
    <div className="bank-details">
      <div>
        <div className='title'>
          <p className='font-size-text'>Bank Details</p>
        </div>
        <div className="piechart-flex">

          <div className="hr-piechart-dashboard">
            <div>
              <PieChart width={190} height={150}>
                <Pie
                  data={data}
                  cx={90}
                  cy={120}
                  startAngle={180}
                  endAngle={0}
                  innerRadius={70}
                  cornerRadius={20}
                  outerRadius={90}
                  paddingAngle={3}
                  dataKey="value"
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={empCOLOURS[index % empCOLOURS.length]} />
                  ))}
                </Pie>
              </PieChart>
            </div>
            <div className="label bank-label">
              <div
                className="dot "
                style={{ backgroundColor: "#FF747C" }}
              ></div>
              <div>Total Employee <strong>56%</strong></div>

            </div>
          </div>


          <div className="hr-piechart-dashboard">
            <div>
              <PieChart width={190} height={150}>
                <Pie
                  data={dataa}
                  cx={90}
                  cy={120}
                  startAngle={180}
                  endAngle={0}
                  innerRadius={70}
                  cornerRadius={20}
                  outerRadius={90}
                  paddingAngle={3}
                  dataKey="value"
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={detCOLOURS[index % detCOLOURS.length]} />
                  ))}

                </Pie>
              </PieChart>
            </div>
            <div className="label bank-label">
              <div
                className="dot "
                style={{ backgroundColor: "#F7BA1E" }}
              ></div>
              <div>Add Details <strong>56%</strong></div>

            </div>
          </div>



          <div className="hr-piechart-dashboard">
            <div>
              <PieChart width={190} height={150}>
                <Pie
                  data={dataaa}
                  cx={90}
                  cy={120}
                  startAngle={180}
                  endAngle={0}
                  innerRadius={70}
                  cornerRadius={20}
                  outerRadius={90}
                  fill="green"
                  paddingAngle={3}
                  dataKey="value"
                >
                  {data.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={pendingCOLORS[index % pendingCOLORS.length]} />
                  ))}
                </Pie>
              </PieChart>
            </div>
            <div className="label bank-label">
              <div
                className="dot "
                style={{ backgroundColor: "#06AD06" }}
              ></div>
              <div>Pending Details <strong>56%</strong></div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

const PaymentDashboard = () => {
  return (
    <>
      <SummaryStats />
      <div className='paymentDashboard' style={{ marginRight: "18px" }}>
        <div className='payrollHistoryBox'>
          <PayrollHistory />
        </div>
        <div className='paymentDashboard-b'>
          <PaymentStatus />
          <BankDetails />
        </div>
      </div>
    </>
  );
};


const EditIncrementData = ({ i, subCompany, subCompanyName, getIncrementslist }) => {
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState(i);
  const [letterTemplate, setLetterTemp] = useState([]);
  const [subcompanydata, setSubcompany] = useState({});


  const handleClose = () => setShow(false);
  const handleShow = () => {
    setEditData(i);
    getLetterTemplate();
    setShow(true)
  };

  const getLetterTemplate = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/wfm/letter-builder-template-bysubcompany/${subCompany}/`);
      setLetterTemp(response.data);
    } catch (error) {
      console.error("Error fetching template:", error);
    }
  };

  const loadLetterTemplate = async () => {
    try {
      const { template, subcompany } = await fetchExistingLetterTemplate({
        subcompanyId: editData?.sub_company,
        // emp_code: i?.empcode,
      });

      if (template && !editData?.letter_template) {
        setEditData(prev => ({ ...prev, letter_template: template.id }));
      }
      if (subcompany) setSubcompany(subcompany);
    } catch (err) {
      toast.warning("Could not fetch letter template");
    }
  };


  useEffect(() => {
    if (show) {
      loadLetterTemplate();
    }
  }, [show])



  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    setLoading(true); //loading logic
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      // const response = await axios.put(`${BASE_URL}/wfm/increment-update/${i.id}/`, editData);
      const response = await axios.put(`${BASE_URL}/wfm/increment-update/${i.id}/`, { letter_template: editData.letter_template });
      if (response.status === 200) {
        toast.success('Increments Updated successfully!');
        await getIncrementslist()
        handleClose()
      }
    } catch (error) {
      console.error('Error Updating Increment:', error);
      toast.err('Error Updating Increment Details.');
      handleAllError(error)
    } finally {
      setLoading(false); //loading logic
      toast.dismiss(loadingToastId);
    }
  };


  const defaultTemplate = {
    header_logo: subcompanydata?.company_logo || null,
    header_company_name: subcompanydata?.title || null,
    header_Address: subcompanydata?.company_address || null,
    header_email: subcompanydata?.company_email || null,

  };

  // const renderHeader = (template) => {
  //   if (template?.header_full_image) {
  //     return (
  //       <div
  //         className='salaryslip-header'
  //         style={{
  //           padding: '5px',
  //           alignItems: 'start'
  //         }}
  //       >
  //         <img
  //           src={template.header_full_image}
  //           alt="Header Full Image"
  //           className="salaryslip-fullimage increement-s-header-image"
  //         />
  //       </div>
  //     );
  //   }

  //   const hasHeaderContent =
  //     template?.header_logo ||
  //     template?.header_company_name ||
  //     template?.header_Address ||
  //     template?.header_email;

  //   if (hasHeaderContent) {
  //     return (
  //       <div
  //         className="salaryslip-header"
  //         style={{
  //           padding: '5px',
  //           display: 'flex',
  //           flexWrap: "wrap",
  //           alignItems: "center",
  //           justifyContent: getJustifyContent(template, "header"),
  //         }}
  //       >
  //         {/* Logo */}

  //         <div className="salaryslip-header-left"
  //           style={{
  //             order:
  //               template?.header_logo_position === "left"
  //                 ? 0
  //                 : template?.header_logo_position ===
  //                   "right"
  //                   ? 2
  //                   : 1,
  //             display: "flex",
  //             justifyContent:
  //               template?.header_logo_position === "center"
  //                 ? "center"
  //                 : getJustifyContentMore(template, "header"),
  //             // justifyContent: getJustifyContentMore("header"),
  //             // width:
  //             //   template?.header_logo_position ===
  //             //     "center" ||
  //             //     template?.header_content_position ===
  //             //     "center"
  //             //     ? "100%"
  //             //     : "auto",
  //             // flex:
  //             //   template?.header_logo_position ===
  //             //     "center" ||
  //             //     template?.header_content_position ===
  //             //     "center"
  //             //     ? "0 0 100%"
  //             //     : "0 0 auto",
  //             width:
  //               template?.header_logo_position === "center"
  //                 ? "100%"
  //                 : "auto",
  //             flex:
  //               template?.header_logo_position === "center"
  //                 ? "0 0 100%"
  //                 : "0 0 auto",
  //           }}
  //         >
  //           {template?.header_logo && (
  //             <img
  //               src={
  //                 template?.header_logo instanceof File
  //                   ? URL.createObjectURL(
  //                     template?.header_logo
  //                   )
  //                   : template?.header_logo
  //               }
  //               alt="Logo"
  //               className="salaryslip-logo"
  //               style={{
  //                 height: '25px', paddingTop: '0px', objectFit: "contain",
  //                 width: "auto",
  //                 maxWidth: "100%",
  //               }}
  //             />
  //           )}
  //         </div>


  //         {/* Company Info */}

  //         <div className="salaryslip-header-right" style={{
  //           fontSize: '3px',

  //           order:
  //             template?.header_content_position === "left"
  //               ? 0
  //               : template?.header_content_position ===
  //                 "right"
  //                 ? 2
  //                 : 1,
  //           width:
  //             template?.header_logo_position === "center" ||
  //               template?.header_content_position === "center"
  //               ? "100%"
  //               : "auto",
  //           flex:
  //             template?.header_logo_position === "center" ||
  //               template?.header_content_position === "center"
  //               ? "0 0 100%"
  //               : "0 0 auto",
  //           textAlign:
  //             template?.header_content_position === "right"
  //               ? "right"
  //               : template?.header_content_position ===
  //                 "center"
  //                 ? "center"
  //                 : "left",
  //           display: "flex",
  //           flexDirection: "column",
  //           alignItems:
  //             template?.header_content_position === "right"
  //               ? "flex-end"
  //               : template?.header_content_position ===
  //                 "center"
  //                 ? "center"
  //                 : "flex-start",
  //           // justifyContent: getJustifyContentMore("header"),
  //           justifyContent:
  //             template?.header_content_position === "center"
  //               ? "center"
  //               : getJustifyContentMore(template, "header"),
  //         }}
  //         >

  //           {template.header_company_name && (
  //             <div className="font-weight600 font-size-heading"
  //               style={{
  //                 color:
  //                   template?.header_primary_colour ||
  //                   "black",
  //               }}>
  //               {template.header_company_name}
  //             </div>
  //           )}
  //           {(template.header_Address || template.header_email) && (
  //             <div className="font-weight400 font-size-subheading"
  //               style={{
  //                 color:
  //                   template?.header_secondery_colour ||
  //                   "black",
  //               }}>
  //               {template.header_Address && (
  //                 <div
  //                   className='inc-header-address'
  //                   dangerouslySetInnerHTML={{ __html: template.header_Address }}
  //                 />
  //               )}
  //               {template.header_email && <div>{template.header_email}</div>}
  //             </div>
  //           )}
  //         </div>

  //       </div>
  //     );
  //   }

  //   return null;
  // };

  const renderHeader = (template) => {
    if (template?.header_full_image) {
      return (
        <div
          className='salaryslip-header'
          style={{
            padding: '5px',
            alignItems: 'start'
          }}
        >
          <img
            src={template.header_full_image}
            alt="Header Full Image"
            className="salaryslip-fullimage increement-s-header-image"
          />
        </div>
      );
    }

    const hasHeaderContent =
      template?.header_logo ||
      template?.header_company_name ||
      template?.header_Address ||
      template?.header_email;

    if (hasHeaderContent) {
      // Get positions
      const logoPosition = template?.header_logo_position || 'left';
      const contentPosition = template?.header_content_position || 'left';

      // Helper to determine which column each element goes to
      const getColumn = (position) => {
        switch (position) {
          case 'left': return 'left';
          case 'center': return 'center';
          case 'right': return 'right';
          default: return 'left';
        }
      };

      const logoColumn = getColumn(logoPosition);
      const contentColumn = getColumn(contentPosition);

      const getGridTemplate = () => {
        // Both in center
        if (logoColumn === 'center' && contentColumn === 'center') {
          return '1fr 2fr 1fr';
        }
        // Both in left
        if (logoColumn === 'left' && contentColumn === 'left') {
          return 'auto 1fr 1fr';
        }
        // Both in right
        if (logoColumn === 'right' && contentColumn === 'right') {
          return '1fr 1fr auto';
        }
        // Logo in left, content in center
        if (logoColumn === 'left' && contentColumn === 'center') {
          return 'auto 1fr 1fr';
        }
        // Logo in left, content in right
        if (logoColumn === 'left' && contentColumn === 'right') {
          return 'auto 1fr auto';
        }
        // Logo in center, content in left
        if (logoColumn === 'center' && contentColumn === 'left') {
          return '1fr auto 1fr';
        }
        // Logo in center, content in right
        if (logoColumn === 'center' && contentColumn === 'right') {
          return '1fr auto 1fr';
        }
        // Logo in right, content in left
        if (logoColumn === 'right' && contentColumn === 'left') {
          return 'auto 1fr auto';
        }
        // Logo in right, content in center
        if (logoColumn === 'right' && contentColumn === 'center') {
          return '1fr 1fr auto';
        }
        // Default
        return '1fr 1fr 1fr';
      };


      const renderContent = (template) => {
        return (
          <>
            {template.header_company_name && (
              <div className="font-weight600 font-size-heading"
                style={{
                  color: template?.header_primary_colour || "black",
                }}>
                {template.header_company_name}
              </div>
            )}
            {(template.header_Address || template.header_email) && (
              <div className="font-weight400 font-size-subheading"
                style={{
                  color: template?.header_secondery_colour || "black",
                }}>
                {template.header_Address && (
                  <div
                    className='inc-header-address'
                    dangerouslySetInnerHTML={{ __html: template.header_Address }}
                  />
                )}
                {template.header_email && <div>{template.header_email}</div>}
              </div>
            )}
          </>
        );
      };


      return (
        <div
          className="salaryslip-header"
          style={{
            padding: '10px 5px',
            display: 'grid',
            gridTemplateColumns: getGridTemplate(),
            alignItems: 'center',
            gap: '15px',
            // width: '100%'
          }}
        >
          {/* Left Column */}
          <div
            className='salaryslip-header-left'
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexDirection: 'row',
              gap: '5px'
            }}>
            {logoColumn === 'left' && template?.header_logo && (
              <img
                src={template?.header_logo instanceof File
                  ? URL.createObjectURL(template?.header_logo)
                  : template?.header_logo}
                alt="Logo"
                style={{
                  height: '40px',
                  objectFit: "contain",
                  width: "auto",
                  maxWidth: "100%",
                }}
              />
            )}
            {contentColumn === 'left' && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                textAlign: 'left',
                width: '100%',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                minWidth: 0
              }}>
                {renderContent(template)}
              </div>
            )}
          </div>

          {/* Center Column */}
          <div
            className='salaryslip-header-left'
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'row',
              gap: '5px'
            }}>
            {logoColumn === 'center' && template?.header_logo && (
              <img
                src={template?.header_logo instanceof File
                  ? URL.createObjectURL(template?.header_logo)
                  : template?.header_logo}
                alt="Logo"
                style={{
                  height: '40px',
                  objectFit: "contain",
                  width: "auto",
                  maxWidth: "100%",
                }}
              />
            )}
            {contentColumn === 'center' && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                width: '100%',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                minWidth: 0
              }}>
                {renderContent(template)}
              </div>
            )}
          </div>

          {/* Right Column */}
          <div
            className='salaryslip-header-left'
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              flexDirection: 'row',
              gap: '5px'
            }}>
            {logoColumn === 'right' && template?.header_logo && (
              <img
                src={template?.header_logo instanceof File
                  ? URL.createObjectURL(template?.header_logo)
                  : template?.header_logo}
                alt="Logo"
                style={{
                  height: '40px',
                  objectFit: "contain",
                  width: "auto",
                  maxWidth: "100%",
                }}
              />
            )}
            {contentColumn === 'right' && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                textAlign: 'right',
                width: '100%',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                minWidth: 0
              }}>
                {renderContent(template)}
              </div>
            )}
          </div>
        </div>
      );
    }

    return null;
  };

  // const renderFooter = (template) => {
  //   if (template?.footer_full_image) {
  //     return (
  //       <div
  //         className='salaryslip-header'
  //         style={{
  //           padding: '5px',
  //           alignItems: 'start'
  //           // paddingLeft: `${template?.footer_left_gap}px`,
  //           // paddingRight: `${template?.footer_right_gap}px`,
  //           // paddingTop: `${template?.footer_top_gap}px`,
  //           // paddingBottom: `${template?.footer_bottom_gap}px`,
  //         }}
  //       >
  //         <img
  //           src={template?.footer_full_image}
  //           alt="Header Full Image"
  //           className="salaryslip-fullimage increement-s-header-image"
  //         />
  //       </div>
  //     );
  //   }

  //   const hasFooterContent =
  //     template?.footer_logo ||
  //     template?.footer_company_name ||
  //     template?.footer_Address ||
  //     template?.footer_email;

  //   if (hasFooterContent) {
  //     return (
  //       <>
  //         <div
  //           className="salaryslip-header"
  //           style={{
  //             padding: '5px',
  //             display: 'flex',
  //             flexWrap: "wrap",
  //             alignItems: "center",
  //             justifyContent: getJustifyContent(template, "footer"),
  //           }}
  //         >
  //           {/* Logo */}

  //           <div className="salaryslip-header-left"
  //             style={{
  //               order:
  //                 template?.footer_logo_position === "left"
  //                   ? 0
  //                   : template?.footer_logo_position === "right"
  //                     ? 2
  //                     : 1,

  //               display: "flex",
  //               justifyContent:
  //                 template?.footer_logo_position === "center"
  //                   ? "center"
  //                   : getJustifyContentMore(template, "footer"),
  //               width:
  //                 template?.footer_logo_position === "center"
  //                   ? "100%"
  //                   : "auto",
  //               flex:
  //                 template?.footer_logo_position === "center"
  //                   ? "0 0 100%"
  //                   : "0 0 auto",
  //             }}>
  //             {template?.footer_logo && (
  //               <img
  //                 src={template?.footer_logo instanceof File
  //                   ? URL.createObjectURL(
  //                     template?.footer_logo
  //                   )
  //                   : template?.footer_logo}
  //                 alt="Logo"
  //                 className="salaryslip-logo"
  //                 style={{
  //                   height: '25px', width: "auto",
  //                   maxWidth: "100%", paddingTop: '0px', objectFit: "contain",
  //                 }}
  //               />
  //             )}
  //           </div>


  //           {/* Company Info */}
  //           <div className="salaryslip-header-right" style={{
  //             fontSize: '3px',
  //             order:
  //               template?.footer_content_position === "left"
  //                 ? 0
  //                 : template?.footer_content_position ===
  //                   "right"
  //                   ? 2
  //                   : 1,
  //             width:
  //               template?.footer_logo_position === "center"
  //                 ||
  //                 template?.footer_content_position === "center"
  //                 ? "100%"
  //                 : "auto",
  //             flex:
  //               template?.footer_logo_position === "center"
  //                 ||
  //                 template?.footer_content_position === "center"
  //                 ? "0 0 100%"
  //                 : "0 0 auto",

  //             textAlign:
  //               template?.footer_content_position === "right"
  //                 ? "right"
  //                 : template?.footer_content_position ===
  //                   "center"
  //                   ? "center"
  //                   : "left",
  //             display: "flex",
  //             flexDirection: "column",
  //             alignItems:
  //               template?.footer_content_position === "right"
  //                 ? "flex-end"
  //                 : template?.footer_content_position ===
  //                   "center"
  //                   ? "center"
  //                   : "flex-start",
  //             // justifyContent: getJustifyContent("footer"),
  //             justifyContent:
  //               template?.header_logo_position === "center"
  //                 ? "center"
  //                 : getJustifyContentMore(template, "footer"),
  //           }}

  //           >
  //             {template?.footer_company_name && (
  //               <div className="font-weight600 font-size-heading"
  //                 style={{
  //                   color:
  //                     template?.footer_primary_colour || "black",
  //                 }}>
  //                 {template?.footer_company_name}
  //               </div>
  //             )}
  //             {(template?.footer_Address || template?.footer_email) && (
  //               <div className="font-weight400 font-size-subheading"
  //                 style={{
  //                   color:
  //                     template?.footer_secondery_colour ||
  //                     "black",
  //                 }}
  //               >
  //                 {template?.footer_Address && <div className='inc-header-address' dangerouslySetInnerHTML={{ __html: template?.footer_Address }} ></div>}
  //                 {template?.footer_email && <div>{template?.footer_email}</div>}
  //               </div>
  //             )}
  //           </div>

  //         </div>
  //       </>
  //     );
  //   }
  //   return null;
  // };


  const renderFooter = (template) => {
    if (template?.footer_full_image) {
      return (
        <div
          className='salaryslip-header'
          style={{
            padding: '5px',
            alignItems: 'start'
          }}
        >
          <img
            src={template.footer_full_image}
            alt="Footer Full Image"
            className="salaryslip-fullimage increement-s-header-image"
          />
        </div>
      );
    }

    const hasFooterContent =
      template?.footer_logo ||
      template?.footer_company_name ||
      template?.footer_Address ||
      template?.footer_email;

    if (hasFooterContent) {
      const logoPosition = template?.footer_logo_position || 'left';
      const contentPosition = template?.footer_content_position || 'left';

      const getColumn = (position) => {
        switch (position) {
          case 'left': return 'left';
          case 'center': return 'center';
          case 'right': return 'right';
          default: return 'left';
        }
      };

      const logoColumn = getColumn(logoPosition);
      const contentColumn = getColumn(contentPosition);

      const getGridTemplate = () => {
        // Both in center
        if (logoColumn === 'center' && contentColumn === 'center') {
          return '1fr 2fr 1fr';
        }
        // Both in left
        if (logoColumn === 'left' && contentColumn === 'left') {
          return 'auto 1fr 1fr';
        }
        // Both in right
        if (logoColumn === 'right' && contentColumn === 'right') {
          return '1fr 1fr auto';
        }
        // Logo in left, content in center
        if (logoColumn === 'left' && contentColumn === 'center') {
          return 'auto 1fr 1fr';
        }
        // Logo in left, content in right
        if (logoColumn === 'left' && contentColumn === 'right') {
          return 'auto 1fr auto';
        }
        // Logo in center, content in left
        if (logoColumn === 'center' && contentColumn === 'left') {
          return '1fr auto 1fr';
        }
        // Logo in center, content in right
        if (logoColumn === 'center' && contentColumn === 'right') {
          return '1fr auto 1fr';
        }
        // Logo in right, content in left
        if (logoColumn === 'right' && contentColumn === 'left') {
          return 'auto 1fr auto';
        }
        // Logo in right, content in center
        if (logoColumn === 'right' && contentColumn === 'center') {
          return '1fr 1fr auto';
        }
        // Default
        return '1fr 1fr 1fr';
      };

      const renderFooterContent = (template) => {
        return (
          <>
            {template?.footer_company_name && (
              <div className="font-weight600 font-size-heading"
                style={{
                  color: template?.footer_primary_colour || "black",
                }}>
                {template?.footer_company_name}
              </div>
            )}
            {(template?.footer_Address || template?.footer_email) && (
              <div className="font-weight400 font-size-subheading"
                style={{
                  color: template?.footer_secondery_colour || "black",
                }}
              >
                {template?.footer_Address && <div className='inc-header-address' dangerouslySetInnerHTML={{ __html: template?.footer_Address }} />}
                {template?.footer_email && <div>{template?.footer_email}</div>}
              </div>
            )}
          </>
        );
      };

      return (
        <div
          // className="salaryslip-footer"
          style={{
            backgroundColor: 'white',
            padding: '10px 5px',
            display: 'grid',
            gridTemplateColumns: getGridTemplate(),
            alignItems: 'center',
            gap: '15px',
            // width: '100%'
          }}
        >
          {/* Left Column */}
          <div

            className='salaryslip-header-left'
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexDirection: 'row',
              gap: '5px'
            }}>
            {logoColumn === 'left' && template?.footer_logo && (
              <img
                src={template?.footer_logo instanceof File
                  ? URL.createObjectURL(template?.footer_logo)
                  : template?.footer_logo}
                alt="Logo"
                style={{
                  height: '40px',
                  objectFit: "contain",
                  width: "auto",
                  maxWidth: "100%",
                }}
              />
            )}
            {contentColumn === 'left' && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                textAlign: 'left',
                width: '100%',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                minWidth: 0
              }}>
                {renderFooterContent(template)}
              </div>
            )}
          </div>

          {/* Center Column */}
          <div
            className='salaryslip-header-left'
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'row',
              gap: '5px'

            }}>
            {logoColumn === 'center' && template?.footer_logo && (
              <img
                src={template?.footer_logo instanceof File
                  ? URL.createObjectURL(template?.footer_logo)
                  : template?.footer_logo}
                alt="Logo"
                style={{
                  height: '40px',
                  objectFit: "contain",
                  width: "auto",
                  maxWidth: "100%",
                }}
              />
            )}
            {contentColumn === 'center' && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                width: '100%',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                minWidth: 0
              }}>
                {renderFooterContent(template)}
              </div>
            )}
          </div>

          {/* Right Column */}
          <div
            className='salaryslip-header-left'
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              flexDirection: 'row',
              gap: '5px'
            }}>
            {logoColumn === 'right' && template?.footer_logo && (
              <img
                src={template?.footer_logo instanceof File
                  ? URL.createObjectURL(template?.footer_logo)
                  : template?.footer_logo}
                alt="Logo"
                style={{
                  height: '40px',
                  objectFit: "contain",
                  width: "auto",
                  maxWidth: "100%",
                }}
              />
            )}
            {contentColumn === 'right' && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                textAlign: 'right',
                width: '100%',
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                whiteSpace: 'normal',
                minWidth: 0
              }}>
                {renderFooterContent(template)}
              </div>
            )}
          </div>
        </div>
      );
    }
    return null;
  };

  const renderBgImage = (template) => {
    const imageUrl = template?.bg_image || subcompanydata?.company_logo;
    if (!imageUrl) return null;

    if (!template) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
          <div
            style={{
              width: '180px',
              // maxHeight: '70vh',
              height: '180px',
              backgroundImage: `url(${subcompanydata?.company_logo})`,
              backgroundSize: `100%`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              opacity: '20%',
              transform: 'none',
            }}
          />
        </div>

      )
    }

    if (template?.bg_image) {

      return (
        <div style={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
          <div
            style={{
              width: '180px',
              // maxHeight: '70vh',
              height: '180px',
              backgroundImage: `url(${template.bg_image})`,
              backgroundSize: `${template.bg_size || 100}%`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              opacity: (template.bg_opacity || 100) / 100,
              transform: template.bg_angle
                ? `rotate(${template.bg_angle}deg)`
                : 'none',
            }}
          />
        </div>
      )
    }
    return null
  };

  const renderSignature = (template) => {
    if (template?.signatory_display) {

      return (
        <div
          style={{
            height: '100%',
            display: "flex",
            justifyContent:
              template?.signatory_overall_position === "center"
                ? "center"
                : template?.signatory_overall_position === "right"
                  ? "flex-end"
                  : "flex-start",
            width: "100%",
            fontSize: '7px'
          }}
        >
          <div
            className="letter-template-signatory"
            style={{
              textAlign:
                template?.signatory_content_position === "center"
                  ? "center"
                  : template?.signatory_content_position === "right"
                    ? "right"
                    : "left",
            }}
          >
            {template?.signatory_sign_heading && (
              <p className="font-weight600" style={{ marginBottom: '0px' }}>
                {template.signatory_sign_heading}
              </p>
            )}

            {template?.signatory_signature && (
              <img
                src={
                  template.signatory_signature instanceof File
                    ? URL.createObjectURL(
                      template?.signatory_signature
                    )
                    : template?.signatory_signature
                }
                alt="Signature"
                style={{
                  height: '30px',
                  display: "block",
                  margin:
                    template?.signatory_sign_position === "center"
                      ? "3px auto"
                      : template?.signatory_sign_position === "right"
                        ? "3px 0 3px auto"
                        : "3px auto 3px 0",
                }}
              />
            )}

            {template?.signatory_name && (
              <p
                className="font-weight600"
                style={{ marginBottom: "3px" }}
              >
                {template?.signatory_name}
              </p>
            )}

            {template?.signatory_designation && (
              <p>{template?.signatory_designation}</p>
            )}
          </div>
        </div>
      )
    }
    return null
  };

  const getPageSizeStyles = (size) => {
    switch (size) {
      case 'A4':
        return { width: '210mm', height: '297mm' };
      case 'A3':
        return { width: '297mm', height: '420mm' };
      case 'letter':
        return { width: '8.5in', height: '11in' };
      default:
        return { width: '210mm', height: '297mm' };
    }
  };



  const pageSizeStyle = editData?.letter_template ? getPageSizeStyles(Array.isArray(letterTemplate) ? letterTemplate?.find(t => t?.id === editData.letter_template)?.page_size : undefined) : {};

  const getScalingFactor = (size) => {
    switch (size) {
      case 'A4':
        return 0.4;
      case 'A3':
        return 0.3;
      case 'letter':
        return 0.35;
      default:
        return 0.4;
    }
  };

  const scalingFactor = editData?.letter_template
    ? getScalingFactor(letterTemplate?.find(t => t.id === editData.letter_template)?.page_size)
    : 0.4;


  // const selectedTemplate = letterTemplate.length > 0 && letterTemplate?.find(
  //   t => t.id === editData?.letter_template
  // );
  const selectedTemplate = letterTemplate?.find(
    t => t.id === editData?.letter_template
  ) || null;

  const getJustifyContent = (template, type = "header") => {
    const positionPrefix = type === "header" ? "header_" : "footer_";

    const logo_position = template[`${positionPrefix}logo_position`];
    const content_position =
      template[`${positionPrefix}content_position`];

    if (logo_position === "left" && content_position === "left")
      return "flex-start";
    if (logo_position === "right" && content_position === "right")
      return "flex-end";
    // if (logo_position === "center" && content_position === "left")
    //     return "flex-start";
    if (logo_position === "right" && content_position === "center")
      return "flex-end";
    if (logo_position === "center") return "center";
    if (logo_position === "center" && content_position === "center")
      return "center";

    return "space-between";
  };

  const getJustifyContentMore = (template, type = "header") => {
    const positionPrefix = type === "header" ? "header_" : "footer_";

    const logo = template[`${positionPrefix}logo_position`];
    const content = template[`${positionPrefix}content_position`];

    if (logo === "center" || content === "center") return "center";
    if (logo === "right" || content === "right") return "flex-end";
    return "flex-start";
  };


  return (
    <>
      {i?.id && (
        <button
          className="model-edit-button-ml"
          style={{ padding: '8px 11px' }}
          title="Edit"
          onClick={handleShow}
        >
          <UpdatePencil />
        </button>
      )}

      <Modal show={show} onHide={handleClose} dialogClassName='half-modal'  >
        <Modal.Header closeButton>
          <Modal.Title>
            Edit Employee Increment - <span className="dynamic-modal-title">{editData.empcode}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div
            className="d-flex justify-content-center p-4 modal-body"
            style={{
              position: 'relative',
              height: '70vh',
              overflow: 'auto',
            }}
          >
            <table className="data-table">
              <tbody>
                <tr>
                  <td className="label">Department Name :</td>
                  <td>{editData?.department_name ? editData?.department_name : '-'}</td>
                </tr>
                <tr>
                  <td className="label">Employee Name :</td>
                  <td>{editData?.emp_name ? editData?.emp_name : '-'}</td>
                </tr>
                <tr>
                  <td className="label">Existing CTC :</td>
                  <td>{editData.existing_ctc ? editData.existing_ctc : '-'}</td>
                </tr>
                <tr>
                  <td className="label">Increment Amount :</td>
                  <td>{editData.increment_amount ? editData.increment_amount : '-'}</td>
                </tr>
                <tr>
                  <td className="label">Increment Percentage :</td>
                  <td>{editData.increment_percentage ? editData.increment_percentage : '-'} </td>
                </tr>
                <tr>
                  <td className="label">Letter Type :</td>
                  <td>{editData.letter_type ? editData.letter_type : '-'} </td>
                </tr>
                <tr>
                  <td className="label">Old Designation :</td>
                  <td>{editData.old_designation ? editData.old_designation : '-'} </td>
                </tr>
                <tr>
                  <td className="label">Previous Grade :</td>
                  <td>{editData.previous_grade ? editData.previous_grade : '-'}</td>
                </tr>
                <tr>
                  <td className="label">Revised CTC :</td>
                  <td>{editData.revised_ctc ? editData.revised_ctc : '-'}</td>
                </tr>
                <tr>
                  <td className="label">Update Grade :</td>
                  <td>{editData.update_grade ? editData.update_grade : '-'}</td>
                </tr>
                <tr>
                  <td className="label">Updated Designation :</td>
                  <td>{editData.updated_designation ? editData.updated_designation : '-'}</td>
                </tr>
                <tr>
                  <td className="label">Upload Datetime :</td>
                  <td>{editData.upload_datetime ? formatDate(editData.upload_datetime) : '-'}</td>
                </tr>

                <tr>
                  <td className="label">Uploaded By :</td>
                  <td>{editData.uploaded_by ? editData.uploaded_by : '-'}</td>
                </tr>
                <tr>
                  <td className="label">WEF Date :</td>
                  <td>{editData.wefdate ? formatDate(editData.wefdate) : '-'}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="form-flex-wrap justify-center align-center">
            <label className="form-labels font-weight500 font-size-subheading" >
              Letter Template :
            </label>

            {letterTemplate && (
              <select
                name="letter_template"
                onChange={(e) =>
                  setEditData(prev => ({
                    ...prev,
                    letter_template: e.target.value === "" ? null : e.target.value
                  }))
                }
                value={editData.letter_template || ""}
                className="form-input font-size-subheading"
              >
                <option value="">No Letter Template</option>
                {letterTemplate?.map((template, index) => (
                  <option key={index} value={template.id}>
                    {template.template_name}
                  </option>
                ))}
              </select>
            )}

          </div>


          <hr />
          <div className="flex justify-center" style={{ height: '300px', width: '263px', margin: '0px auto 0px auto' }}>
            <div
              className="letter-container"

              style={{
                ...pageSizeStyle,
                position: 'relative',
                backgroundColor: '#fff',
                border: '1px solid #ccc',
                // transform: `scale(${scalingFactor})`,
                // transformOrigin: 'top left',
                width: '100%',
                height: '100%',
                // overflow: 'hidden',
              }}
            >

              <div style={{ position: 'absolute', top: 0, left: 0, width: '100%' }}>
                {renderHeader(selectedTemplate || defaultTemplate)}
              </div>


              <div style={{
                position: 'absolute', top: '19%', bottom: `${!selectedTemplate?.bg_image && '19%'}`, zIndex: 1, width: '100%', borderTop: '0.3px solid rgb(228 227 227)', borderBottom: '0.3px solid rgb(228 227 227)', overflow: 'hidden', boxSizing: "border-box",
              }}>
                {renderBgImage(selectedTemplate)}
                <div className='absolute' style={{ top: `${selectedTemplate?.signatory_overall_placement === "Start" ? '20px' : '100px'}`, width: '92%', padding: '10px' }}>
                  {renderSignature(selectedTemplate)}
                </div>
              </div>

              <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
                {renderFooter(letterTemplate?.find(t => t.id === editData?.letter_template))}
              </div>
            </div>
          </div>

          {/* <div className="flex justify-center m-3">
          <button
            className="justify-center model-button model-button-cancel font-weight500"
            onClick={handleClose}
          >
            Close
          </button>
        </div> */}
          <div className="button-models">
            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
              Cancel
            </button>

            <button className="model-button-download model-button font-weight500" onClick={handleSubmit} disabled={loading}>
              {"  "} {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};


// const UploadIncrementDataBulk = ({ id, getDatalist }) => {
//   const [show, setShow] = useState(false);
//   const handleShow = () => {
//     setShow(true)
//   };

//   const [fileName, setFileName] = useState("");
//   const [docErrors, setDocErrors] = useState({});
//   const [docInputState, setDocInputState] = useState({});
//   const [jsonData, setJsonData] = useState(null);


//   const handleClose = () => {
//     setFileName("")
//     setJsonData(null);
//     setDocInputState({});
//     setDocErrors({})
//     setShow(false)
//   };

//   const convertToYYYYMMDD = (input) => {
//     try {
//       let date;

//       if (typeof input === "number") {
//         const excelEpoch = new Date(1900, 0, 1);
//         const daysOffset = input - 2;
//         date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
//       }

//       else if (typeof input === "string") {
//         // dd.mm.yyyy
//         if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
//           const [day, month, year] = input.split('.');
//           date = new Date(`${year}-${month}-${day}`);
//         }

//         // yyyy.mm.dd
//         else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
//           const [year, month, day] = input.split('.');
//           date = new Date(`${year}-${month}-${day}`);
//         }

//         // dd-mm-yyyy
//         else if (/^\d{2}-\d{2}-\d{4}$/.test(input)) {
//           const [day, month, year] = input.split('-');
//           date = new Date(`${year}-${month}-${day}`);
//         }

//         // yyyy-mm-dd
//         else {
//           date = new Date(input);
//         }
//       }

//       if (isNaN(date?.getTime?.())) {
//         throw new Error("Invalid date format");
//       }

//       const year = date.getFullYear();
//       const month = String(date.getMonth() + 1).padStart(2, '0');
//       const day = String(date.getDate()).padStart(2, '0');

//       return `${year}-${month}-${day}`;
//     } catch (error) {
//       return null;
//     }
//   };


//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     console.log(file);
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = (e) => {
//         const data = new Uint8Array(e.target.result);
//         const workbook = XLSX.read(data, { type: 'array' });

//         console.log("workbook");
//         console.log(workbook);

//         const sheetName = workbook.SheetNames.includes('Increment Sheet')
//           ? 'Increment Sheet'
//           : workbook.SheetNames[0];
//         const worksheet = workbook.Sheets[sheetName];
//         // const worksheet = workbook.Sheets[''];
//         const rawData = XLSX.utils.sheet_to_json(worksheet);

//         console.log("rawData")
//         console.log(rawData)

//         // Convert wefdate to YYYY-MM-DD format
//         const updatedRawData = rawData.map((row) => ({
//           ...row,
//           wefdate: row.wefdate ? convertToYYYYMMDD(row.wefdate) : null, // Convert wefdate
//           uploaded_by: sessionStorage.getItem('emp_code'), // Set uploaded_by to emp_code from sessionStorage
//           existing_ctc: row.existing_ctc ? formatRoundoffCompleteNoComma(row.existing_ctc) : null,
//           increment_amount: row.increment_amount ? formatRoundoffCompleteNoComma(row.increment_amount) : null,
//           increment_percentage: row.increment_percentage ? formatRoundoff2D(row.increment_percentage) : null,
//           revised_ctc: row.revised_ctc ? formatRoundoffCompleteNoComma(row.revised_ctc) : null,
//         }));

//         console.log("updatedRawData");
//         console.log(updatedRawData);

//         setJsonData(updatedRawData); // Set the updated data to jsonData state
//       };
//       reader.readAsArrayBuffer(file);
//       setFileName(file.name);
//     }
//   };


//   const handleFileClear = () => {
//     setFileName("")
//     setJsonData(null);
//     setDocInputState({});
//     setDocErrors({})
//   };


//   const [loading, setLoading] = useState(false); //loading logic
//   const handleSubmit = async () => {
//     setLoading(true); //loading logic
//     const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
//     if (!jsonData) {
//       alert("Please upload an Excel file first!");
//       return;
//     }
//     try {
//       const response = await axios.post(`${BASE_URL}/wfm/incrementbulkadd/`, jsonData);
//       if (response.status === 200) {
//         toast.success('Increments uploaded successfully!');
//         await getDatalist()
//         handleClose()
//       }
//     } catch (error) {
//       console.error('Error uploading Increment:', error);
//       toast.err('Error uploading Increment Details.');
//       handleAllError(error)
//     } finally {
//       setLoading(false); //loading logic
//       toast.dismiss(loadingToastId);
//     }
//   };

//   return (
//     <>
//       <button
//         title="Bulk Upload Salary Data"
//         className="model-button font-weight500 model-button-print"
//         onClick={handleShow}
//         style={{ margin: "2px" }}
//       >
//         <UploadIcon />
//       </button>

//       <Modal show={show} dialogClassName="ourcompany-model">
//         <Modal.Header className="task-Tab-heading font-weight500 flex-row justify-between   font-size-heading ">
//           <Modal.Title>Upload Bulk Increment Data in Format:</Modal.Title>

//           {/* <button
//             //  onClick={handleDownload}
//             className="model-button-download model-button font-weight500" style={{ marginLeft: "35vw" }}>
//             <DownloadIcon />
//             {"  "} Format
//           </button> */}
//           {/* <div style={{ marginLeft: "35vw" }}> */}
//           <DownloadIncrementBulkFormat />
//           {/* </div> */}
//         </Modal.Header>
//         <Modal.Body>
//           <div className="flex-column field-cont-div">
//             <label htmlFor="document_file" className="form-labels font-weight500 font-size-heading">
//               Upload File
//             </label>
//             <label
//               htmlFor="document_file"
//               className={`align-center form-input-attach-container custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
//                 }`}
//             >
//               <div className={`align-center pdf-input  ${docErrors.document_file ? 'error' : ''}`}>
//                 <Attachment />
//               </div>
//             </label>
//             <input
//               type="file"
//               accept=".xlsx, .xls"
//               onChange={handleFileUpload}
//               id="document_file"
//               name="document_file"
//               className="file-inputs align-center"
//               style={{ display: "none", position: "relative" }} />
//             {fileName && <p className="file-name align-center">{fileName}</p>}
//             <br />
//             {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
//           {jsonData &&
//             <div>
//               <button className="model-button" onClick={handleFileClear}>Clear</button>
//             </div>
//     }
//           </div>

//           {jsonData && (
//             <div className="scroll-container-table">
//               <h4>Data to be Uploaded</h4>
//               <table className="scrollfix-table-css">
//                 <thead>
//                   <tr className="custom-table-head-tr">
//                     <th className="align-left">Emp Code</th>
//                     <th className="align-center">WEF Date</th>
//                     <th className="align-center">Letter Type</th>
//                     <th className="align-center">Previous Grade</th>
//                     <th className="align-center">Update Grade</th>
//                     <th className="align-center">Old Designation</th>
//                     <th className="align-center">Updated Designation</th>
//                     <th className="align-center">Existing CTC</th>
//                     <th className="align-center">Increment Percentage</th>
//                     <th className="align-center">Increment Amount</th>
//                     <th className="align-center">Revised CTC</th>
//                     <th className="align-center">Authority Signatory</th>
//                     <th className="align-center">Uploaded By</th>
//                     <th className="align-center">Letter Template</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {jsonData.map((row, index) => (
//                     <tr key={index}>
//                       <td className="align-left">{row.empcode || '-'}</td>
//                       <td className="align-center">{row.wefdate ? formattedDateLong(row.wefdate) : '-'}</td>
//                       <td className="align-center">{row.letter_type || '-'}</td>
//                       <td className="align-center">{row.previous_grade || '-'}</td>
//                       <td className="align-center">{row.update_grade || '-'}</td>
//                       <td className="align-center">{row.old_designation || '-'}</td>
//                       <td className="align-center">{row.updated_designation || '-'}</td>
//                       <td className="align-center">{row.existing_ctc || '-'}</td>
//                       <td className="align-center">{row.increment_percentage || '-'}</td>
//                       <td className="align-center">{row.increment_amount || '-'}</td>
//                       <td className="align-center">{row.revised_ctc || '-'}</td>
//                       <td className="align-center">{row.authority_signatory || '-'}</td>
//                       <td className="align-center">{row.uploaded_by || '-'}</td>
//                       <td className="align-center">{row.letter_template || '-'}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}

//           <div className="button-models">
//             <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//               Cancel
//             </button>

//             <button className="model-button-download model-button font-weight500" onClick={handleSubmit} disabled={loading}>
//               <UploadIcon />
//               {"  "} {loading ? "Uploading..." : "Upload"}
//             </button>
//           </div>
//         </Modal.Body>
//         <ToastContainer position="top-center" autoClose={10000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//       </Modal>
//     </>
//   );
// };


// const DownloadIncrementBulkFormat = () => {
//   const [show, setShow] = useState(false);

//   const handleShow = () => {
//     // toast.warning("Please Select Subcompany First");
//     getIncrementRelatedData();
//     getAllEmployeeData();
//     setShow(true)
//   };
//   const handleClose = () => {
//     setShow(false)
//   };

//   const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
//   const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));


//   const [allEmployeeList, setAllEmployeeList] = useState([]);
//   const [letterTemplatesList, setLetterTemplatesList] = useState([]);
//   const [selectedLetterTemplate, setSelectedLetterTemplate] = useState("");
//   const [selectedLetterTemplateData, setSelectedLetterTemplateData] = useState({});

//   const [showEmpData, setShowEmpData] = useState(false);
//   const [buffer1, setBuffering1] = useState(true);
//   const [buffer2, setBuffering2] = useState(true);


//   useEffect(() => {
//     getIncrementRelatedData();
//     getAllEmployeeData();
//   }, [toggleCompany]);

//   const getIncrementRelatedData = async (emp_code) => {
//     setBuffering1(true); //buffering logic
//     try {
//       const headings = await axios.get(`${BASE_URL}/wfm/letter-builder-template-bysubcompany/${toggleCompany}/`);
//       setLetterTemplatesList(headings.data);
//     } catch (err) {
//       handleErrorToast(err);
//     } finally {
//       setBuffering1(false); //buffering logic
//     }
//   };

//   const currentDate = new Date();
//   const currentMonth = currentDate.getMonth() + 1; // Months are 0-indexed, so add 1
//   const currentYear = currentDate.getFullYear();

//   let getAllEmployeeData = async () => {
//     setBuffering2(true); //buffering logic
//     try {
//       const res = await axios.get(`${BASE_URL}/wfm/salaryslipallupcoming/${currentMonth}/${currentYear}/${toggleCompany}/`);
//       const sortedList = customSortByKey(res.data, "emp_code");
//       setAllEmployeeList(sortedList);
//     } catch (err) {
//       handleErrorToast(err);
//     } finally {
//       setBuffering2(false); //buffering logic
//     }
//   };

//   const handleTemplateSelect = (e) => {
//     const { value } = e.target;
//     setSelectedLetterTemplate(value);

//     const selected = letterTemplatesList.find(
//       (format) => String(format.id) === String(value)
//     );
//     setSelectedLetterTemplateData(selected);

//   };


//   const bulkformattableRef = useRef(null);
//   const s2ab = (s) => {
//     const buf = new ArrayBuffer(s.length);
//     const view = new Uint8Array(buf);
//     for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
//     return buf;
//   };

//   const handleDownload = () => {

//     if (!selectedLetterTemplate) {
//       toast.warning("Please select a Letter Template before downloading the format.");
//       return;
//     }

//     const table = bulkformattableRef.current;
//     const wb = XLSX.utils.table_to_book(table, { sheet: "Increment Sheet" });
//     const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

//     const blob = new Blob([s2ab(wbout)], {
//       type: "application/vnd.ms-excel",
//     });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `Increment_Upload_Format-${selectedLetterTemplateData.sub_company_title || ''}.xls`;
//     a.click();
//     window.URL.revokeObjectURL(url);
//   };


//   return (
//     <>
//       <button
//         title="Bulk Salary Format Download"
//         className="model-button-download model-button font-weight500"
//         onClick={handleShow}
//         style={{ margin: "2px" }}
//       >
//         <DownloadIcon />
//         {"  "} Format
//       </button>



//       <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
//         <Modal.Header closeButton className="task-Tab-heading font-weight500    font-size-heading ">
//           <Modal.Title>Download Bulk Salary Data Format:</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>

//           <div className="form-flex-wrap">
//             {SUPER_ADMIN && <div>
//               <label htmlFor="company" className="form-labels">
//                 Select Company
//               </label>
//               <div className="table-searchh dropdown-container">
//                 <Office />
//                 <select
//                   onChange={(e) => setToggleCompany(e.target.value)}
//                   value={toggleCompany}
//                   className="dropdown font-size-subheading"
//                 >
//                   <option value="null">Select SubCompany</option>
//                   {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
//                 </select>
//               </div>
//             </div>}

//             <div>
//               <label htmlFor="salary_policy" className="form-labels">
//                 Select Letter Template<span className="required">*</span>
//                 {selectedLetterTemplate && (
//                   <ViewLetterBuilder
//                     buttonDisplay={'Eye-Name'}
//                     buttonDisplayName='Preview'
//                     templateID={selectedLetterTemplate}
//                   />
//                 )}
//                 {/* {selectedLetterTemplateData !== "null" && <ViewLetterTemplate i={selectedLetterTemplateData} />} */}
//               </label>
//               <div className="table-searchh dropdown-container">
//                 {buffer1 ? <div className="spinner-vsmall"></div> : <Filter />}
//                 <select
//                   value={selectedLetterTemplate}
//                   onChange={handleTemplateSelect}
//                   className="dropdown font-size-subheading"
//                 >
//                   <option value="">Select Letter Template</option>
//                   {letterTemplatesList?.map((i) => (
//                     <option key={i.id} value={i.id}>{i.template_name}</option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//             <div className="flex-row">
//               <label className="form-labels">
//                 With Employee {showEmpData ? "Shown" : "Hidden"} : {" "}
//               </label>
//               <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
//               <div className="checkbox-toggle">
//                 <input
//                   type="checkbox"
//                   id="toggle-employees"
//                   name="show_emp_data"
//                   checked={showEmpData}
//                   onChange={() => setShowEmpData(!showEmpData)}
//                 />
//                 <label htmlFor="toggle-employees"></label>
//               </div>
//             </div>
//           </div>


//           {/* Downloading Format */}
//           <h4>Preview Format Excel</h4>
//           <div className="scroll-container-table" style={{ minHeight: '25vh', maxHeight: '50vh', overflowY: 'auto' }}>
//             <table
//               className="scrollfix-table-css"
//               ref={bulkformattableRef}
//               id="my-table"
//               style={{
//                 borderColor: "#323232",
//                 borderRadius: "5px",
//                 padding: "0px 5px",
//                 borderWidth: "1px",
//               }}
//             >
//               <thead>
//                 <tr className="custom-table-head-tr">
//                   <th className="summary-excel-tab br-5">empcode</th>
//                   <th className="summary-excel-tab br-5">wefdate</th>
//                   <th className="summary-excel-tab br-5">letter_type</th>
//                   <th className="summary-excel-tab br-5">previous_grade</th>
//                   <th className="summary-excel-tab br-5">update_grade</th>
//                   <th className="summary-excel-tab br-5">old_designation</th>
//                   <th className="summary-excel-tab br-5">updated_designation</th>
//                   <th className="summary-excel-tab br-5">existing_ctc</th>
//                   <th className="summary-excel-tab br-5">increment_percentage</th>
//                   <th className="summary-excel-tab br-5">increment_amount</th>
//                   <th className="summary-excel-tab br-5">revised_ctc</th>
//                   <th className="summary-excel-tab br-5">authority_signatory</th>
//                   <th className="summary-excel-tab br-5">letter_template</th>
//                   {/* <th className="summary-excel-tab br-5">uploaded_by</th> */}
//                 </tr>
//               </thead>
//               <tbody>
//                 {showEmpData ? (
//                   buffer2 ?
//                     <div className="form-loader">
//                       <div className="bar-loader"></div>
//                     </div>
//                     :
//                     allEmployeeList
//                       .sort((a, b) => a.emp_code - b.emp_code)
//                       .map((data, index) => {
//                         const totalCTC = data.deduction_details.find(
//                           (item) => item.name === "Total CTC"
//                         );
//                         const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";
//                         return (
//                           <tr style={{ color: inactivename }} key={index}>
//                             <td className="summary-excel-tab br-5">{data.emp_code}</td>
//                             <td className="summary-excel-tab br-5"></td> {/* wefdate */}
//                             <td className="summary-excel-tab br-5"></td> {/* letter_type */}
//                             <td className="summary-excel-tab br-5"></td> {/* previous_grade */}
//                             <td className="summary-excel-tab br-5"></td> {/* update_grade */}
//                             <td className="summary-excel-tab br-5">{data.user_details?.designation_name || '-'}</td> {/* old_designation */}
//                             <td className="summary-excel-tab br-5"></td> {/* updated_designation */}
//                             {/* <td className="summary-excel-tab br-5"></td> */} {/* existing_ctc */}
//                             <td className="summary-excel-tab br-5">{totalCTC ? totalCTC.standard_amount : '-'}</td> {/* existing_ctc */}
//                             <td className="summary-excel-tab br-5"></td> {/* increment_percentage */}
//                             <td className="summary-excel-tab br-5"></td> {/* increment_amount */}
//                             <td className="summary-excel-tab br-5"></td> {/* revised_ctc */}
//                             <td className="summary-excel-tab br-5"></td> {/* authority_signatory */}
//                             <td className="summary-excel-tab br-5">{selectedLetterTemplate || ''}</td> {/* letter_template */}
//                             {/* <td className="summary-excel-tab br-5"></td> */} {/* uploaded_by */}
//                           </tr>
//                         )
//                       })
//                 ) : (
//                   <tr>
//                     <td className="summary-excel-tab br-5">[emp_code]</td>
//                     <td className="summary-excel-tab br-5"></td> {/* wefdate */}
//                     <td className="summary-excel-tab br-5"></td> {/* letter_type */}
//                     <td className="summary-excel-tab br-5"></td> {/* previous_grade */}
//                     <td className="summary-excel-tab br-5"></td> {/* update_grade */}
//                     <td className="summary-excel-tab br-5"></td> {/* old_designation */}
//                     <td className="summary-excel-tab br-5"></td> {/* updated_designation */}
//                     {/* <td className="summary-excel-tab br-5"></td> */} {/* existing_ctc */}
//                     <td className="summary-excel-tab br-5"></td> {/* existing_ctc */}
//                     <td className="summary-excel-tab br-5"></td> {/* increment_percentage */}
//                     <td className="summary-excel-tab br-5"></td> {/* increment_amount */}
//                     <td className="summary-excel-tab br-5"></td> {/* revised_ctc */}
//                     <td className="summary-excel-tab br-5"></td> {/* authority_signatory */}
//                     <td className="summary-excel-tab br-5">{selectedLetterTemplate || ''}</td> {/* letter_template */}
//                     {/* <td className="summary-excel-tab br-5"></td> */} {/* uploaded_by */}
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>


//           <div className="button-models">
//             <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//               Cancel
//             </button>
//             <button
//               onClick={handleDownload}
//               className="model-button-download model-button font-weight500"
//               style={{
//                 marginLeft: "35vw",
//                 opacity: !selectedLetterTemplate ? 0.6 : 1, // Dims the button if disabled
//                 cursor: !selectedLetterTemplate ? "not-allowed" : "pointer"
//               }}
//             >
//               <DownloadIcon />
//               {"  "} Format
//             </button>
//           </div>
//         </Modal.Body>
//         <ToastContainer position="top-center" autoClose={10000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

//       </Modal>
//     </>
//   );
// };




const ALLOWED_COLUMNS = [
  { key: "empcode", required: true },
  { key: "wefdate", required: true },
  { key: "letter_type", required: true },
  { key: "previous_grade", required: false },
  { key: "update_grade", required: false },
  { key: "old_designation", required: false },
  { key: "updated_designation", required: false },
  { key: "existing_ctc", required: true },
  { key: "increment_percentage", required: true },
  { key: "increment_amount", required: true },
  { key: "revised_ctc", required: true },
  { key: "authority_signatory", required: true },
  { key: "letter_template", required: false },
];


const MANDATORY_FIELDS = [
  "empcode",
  "wefdate",
  "letter_type",
  "existing_ctc",
  "increment_percentage",
  "increment_amount",
  "revised_ctc",
  "authority_signatory",
];

const UploadIncrementDataBulk = ({ id, getDatalist }) => {
  // ---------- Modal visibility ----------
  const [show, setShow] = useState(false);

  // ---------- Step 2: Upload state ----------
  const [fileName, setFileName] = useState("");
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});
  const [jsonData, setJsonData] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);

  // ---------- Step 1: Download Format state (from DownloadIncrementBulkFormat) ----------
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [allEmployeeList, setAllEmployeeList] = useState([]);
  const [letterTemplatesList, setLetterTemplatesList] = useState([]);
  const [selectedLetterTemplate, setSelectedLetterTemplate] = useState("");
  const [selectedLetterTemplateData, setSelectedLetterTemplateData] = useState({});
  const [showEmpData, setShowEmpData] = useState(false);
  const [buffer1, setBuffering1] = useState(true);
  const [buffer2, setBuffering2] = useState(true);

  const bulkformattableRef = useRef(null);

  const handleShow = () => {
    getIncrementRelatedData();
    getAllEmployeeData();
    setShow(true);
  };

  const handleClose = () => {
    setFileName("");
    setJsonData(null);
    setDocInputState({});
    setDocErrors({});
    setShow(false);
  };

  useEffect(() => {
    if (show) {
      getIncrementRelatedData();
      getAllEmployeeData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleCompany]);

  const getIncrementRelatedData = async () => {
    setBuffering1(true);
    try {
      const headings = await axios.get(`${BASE_URL}/wfm/letter-builder-template-bysubcompany/${toggleCompany}/`);
      setLetterTemplatesList(headings.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering1(false);
    }
  };

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;
  const currentYear = currentDate.getFullYear();

  const getAllEmployeeData = async () => {
    setBuffering2(true);
    try {
      const res = await axios.get(`${BASE_URL}/wfm/salaryslipallupcoming/${currentMonth}/${currentYear}/${toggleCompany}/`);
      const sortedList = customSortByKey(res.data, "emp_code");
      setAllEmployeeList(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering2(false);
    }
  };

  const handleTemplateSelect = (e) => {
    const { value } = e.target;
    setSelectedLetterTemplate(value);
    const selected = letterTemplatesList.find((format) => String(format.id) === String(value));
    setSelectedLetterTemplateData(selected);
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const handleDownload = () => {
    if (!selectedLetterTemplate) {
      toast.warning("Please select a Letter Template before downloading the format.");
      return;
    }
    const table = bulkformattableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: "Increment Sheet" });
    const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });
    const blob = new Blob([s2ab(wbout)], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Increment_Upload_Format-${selectedLetterTemplateData?.sub_company_title || ""}.xls`;
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const convertToYYYYMMDD = (input) => {
    try {
      let date;
      if (typeof input === "number") {
        const excelEpoch = new Date(1900, 0, 1);
        const daysOffset = input - 2;
        date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
      } else if (typeof input === "string") {
        if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
          const [day, month, year] = input.split(".");
          date = new Date(`${year}-${month}-${day}`);
        } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
          const [year, month, day] = input.split(".");
          date = new Date(`${year}-${month}-${day}`);
        } else if (/^\d{2}-\d{2}-\d{4}$/.test(input)) {
          const [day, month, year] = input.split("-");
          date = new Date(`${year}-${month}-${day}`);
        } else {
          date = new Date(input);
        }
      }
      if (isNaN(date?.getTime?.())) {
        throw new Error("Invalid date format");
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    } catch (error) {
      return null;
    }
  };

  // ---------- Mandatory field validation ----------

  const validateMandatoryFields = (rows) => {
    const errors = [];
    rows.forEach((row, idx) => {
      const missing = MANDATORY_FIELDS.filter((field) => {
        const val = row[field];
        return val === null || val === undefined || String(val).trim() === "";
      });
      if (missing.length > 0) {
        errors.push(`Row ${idx + 2}: missing ${missing.join(", ")}`);
      }
    });
    return errors;
  };

  // ---------- File parsing (shared by input-click and drag-drop) ----------
  const processFile = (file) => {
    if (!file) return;
    const isValidExt = /\.(xlsx|xls)$/i.test(file.name);
    if (!isValidExt) {
      setDocErrors({ document_file: "Please upload a valid .xlsx or .xls file" });
      toast.error("Please upload a valid Excel file (.xlsx or .xls)");
      return;
    }
    setDocErrors({});
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames.includes("Increment Sheet")
        ? "Increment Sheet"
        : workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const rawData = XLSX.utils.sheet_to_json(worksheet);

      const updatedRawData = rawData.map((row) => ({
        ...row,
        wefdate: row.wefdate ? convertToYYYYMMDD(row.wefdate) : null,
        uploaded_by: sessionStorage.getItem("emp_code"),
        existing_ctc: row.existing_ctc ? formatRoundoffCompleteNoComma(row.existing_ctc) : null,
        increment_amount: row.increment_amount ? formatRoundoffCompleteNoComma(row.increment_amount) : null,
        increment_percentage: row.increment_percentage ? formatRoundoff2D(row.increment_percentage) : null,
        revised_ctc: row.revised_ctc ? formatRoundoffCompleteNoComma(row.revised_ctc) : null,
      }));

      const mandatoryErrors = validateMandatoryFields(updatedRawData);
      if (mandatoryErrors.length > 0) {
        setJsonData(null);
        setDocInputState({});
        setValidationErrors(mandatoryErrors);
        setDocErrors({
          document_file: `Upload blocked: ${mandatoryErrors.length} row(s) have missing mandatory fields.`,
        });
        toast.error(`Upload blocked: ${mandatoryErrors.length} row(s) have missing mandatory fields.`);
        return;
      }

      setValidationErrors([]);
      setDocErrors({});
      setJsonData(updatedRawData);
      setDocInputState({ document_file: true });
    };
    reader.readAsArrayBuffer(file);
    setFileName(file.name);
  };

  const handleFileUpload = (event) => {
    processFile(event.target.files[0]);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragActive(false);
    processFile(event.dataTransfer.files[0]);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setDragActive(false);
  };

  const handleFileClear = () => {
    setFileName("");
    setJsonData(null);
    setDocInputState({});
    setDocErrors({});
    setValidationErrors([]);
  };

  const handleSubmit = async () => {
    if (!jsonData || jsonData.length === 0) {
      toast.warning("Please upload an Excel file first!");
      return;
    }
    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");
    try {
      const response = await axios.post(`${BASE_URL}/wfm/incrementbulkadd/`, jsonData);
      if (response.status === 200) {
        toast.success("Increments uploaded successfully!");
        await getDatalist();
        handleClose();
      }
    } catch (error) {
      console.error("Error uploading Increment:", error);
      toast.error("Error uploading Increment Details.");
      handleAllError(error);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Bulk Upload Salary Data"
        className="model-button font-weight500 model-button-print"
        onClick={handleShow}
        style={{ margin: "2px" }}
      >
        <UploadIcon />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model increment-bulk-modal">

        <Modal.Header closeButton>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{
                width: 32, height: 32, background: "#E6F1FB", borderRadius: 8,
                display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#185FA5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" />
                </svg>
              </div>
              <Modal.Title style={{ fontSize: 15, fontWeight: 500, lineHeight: 1.3 }}>
                Bulk Upload Increment Data
              </Modal.Title>
            </div>
            <button
              onClick={handleDownload}
              disabled={!selectedLetterTemplate}
              style={{
                opacity: !selectedLetterTemplate ? 0.6 : 1,
                cursor: !selectedLetterTemplate ? "not-allowed" : "pointer",
                display: "flex", alignItems: "center", gap: 6,
                padding: "6px 14px", borderRadius: 8, fontSize: 12, fontWeight: 500,
                background: "#EAF3DE", color: "#3B6D11",
                border: "0.5px solid #97C459",
                marginRight: 36, transition: "all 0.15s"
              }}
            >
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              Download Format
            </button>
          </div>
        </Modal.Header>

        <Modal.Body>
          {/* ---------------- STEP 1 ---------------- */}
          <div className="ib-step-box">
            <span className="ib-step-badge">Step 1</span>
            <p className="ib-step-text">
              Select your <b>Letter Template</b> (and Company, if applicable) below, then click{" "}
              <b>&ldquo;Download Format&rdquo;</b> (top right) to get the Excel template with valid reference
              values. Fill in your data and upload it below.
            </p>
          </div>

          <div className="form-flex-wrap">
            {SUPER_ADMIN && (
              <div>
                <label htmlFor="company" className="form-labels">
                  Select Company
                </label>
                <div className="table-searchh dropdown-container">
                  <Office />
                  <select
                    onChange={(e) => setToggleCompany(e.target.value)}
                    value={toggleCompany}
                    className="dropdown font-size-subheading"
                  >
                    <option value="null">Select SubCompany</option>
                    {SUB_COMPANIES.map((company) => (
                      <option key={company.id} value={company.id}>
                        {company.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            <div>
              <label htmlFor="salary_policy" className="form-labels">
                Select Letter Template<span className="required">*</span>
                {selectedLetterTemplate && (
                  <ViewLetterBuilder
                    buttonDisplay={"Eye-Name"}
                    buttonDisplayName="Preview"
                    templateID={selectedLetterTemplate}
                  />
                )}
              </label>
              <div className="table-searchh dropdown-container">
                {buffer1 ? <div className="spinner-vsmall"></div> : <Filter />}
                <select
                  value={selectedLetterTemplate}
                  onChange={handleTemplateSelect}
                  className="dropdown font-size-subheading"
                >
                  <option value="">Select Letter Template</option>
                  {letterTemplatesList?.map((i) => (
                    <option key={i.id} value={i.id}>
                      {i.template_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="flex-row">
              <label className="form-labels">
                With Employee Data {showEmpData ? "Shown" : "Hidden"}:
              </label>
              <hr style={{ marginTop: "10px" }} className="field-cont-hr" />
              <div className="checkbox-toggle">
                <input
                  type="checkbox"
                  id="toggle-employees"
                  name="show_emp_data"
                  checked={showEmpData}
                  onChange={() => setShowEmpData(!showEmpData)}
                />
                <label htmlFor="toggle-employees"></label>
              </div>
            </div>
          </div>

          <div className="ib-step-box" style={{ marginTop: "10px" }}>
            <span className="ib-step-badge">letter_type Reference</span>
            <div className="ib-step-text-container">
              <p className="ib-step-text">
                In the Excel sheet, the <b>letter_type</b> column decides the subject shown on the Increment
                Letter. Enter only the matching number (1, 2, 3, or 4) as per below:
              </p>
              <ul style={{
                margin: "6px 0 0 0",
                padding: 0,
                fontSize: 13,
                listStyle: "none",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "6px 16px",
              }}>
                <li><b>1</b> — Increment Letter for yearly Performance review</li>
                <li><b>2</b> — Increment Letter for yearly performance review &amp; Promotion Letter</li>
                <li><b>3</b> — Increment, Promotion &amp; Employment Confirmation Letter</li>
                <li><b>4</b> — Increment &amp; Employment Confirmation Letter</li>
              </ul>
            </div>
          </div>


          <h4>Preview Format Excel</h4>
          <div className="scroll-container-table ib-preview-scroll">
            <table
              className="scrollfix-table-css"
              ref={bulkformattableRef}
              id="my-table"
              style={{ borderColor: "#323232", borderRadius: "5px", padding: "0px 5px", borderWidth: "1px" }}
            >
              <thead>
                <tr className="custom-table-head-tr">
                  {ALLOWED_COLUMNS.map((col) => (
                    <th key={col.key} className="summary-excel-tab br-5">
                      {col.key}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {showEmpData ? (
                  buffer2 ? (
                    <tr>
                      <td colSpan={ALLOWED_COLUMNS.length}>
                        <div className="form-loader">
                          <div className="bar-loader"></div>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    allEmployeeList
                      .sort((a, b) => a.emp_code - b.emp_code)
                      .map((data, index) => {
                        const totalCTC = data.deduction_details.find((item) => item.name === "Total CTC");
                        const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";
                        return (
                          <tr style={{ color: inactivename }} key={index}>
                            <td className="summary-excel-tab br-5">{data.emp_code}</td>
                            <td className="summary-excel-tab br-5"></td>
                            <td className="summary-excel-tab br-5"></td>
                            <td className="summary-excel-tab br-5"></td>
                            <td className="summary-excel-tab br-5"></td>
                            <td className="summary-excel-tab br-5">{data.user_details?.designation_name || "-"}</td>
                            <td className="summary-excel-tab br-5"></td>
                            <td className="summary-excel-tab br-5">{totalCTC ? totalCTC.standard_amount : "-"}</td>
                            <td className="summary-excel-tab br-5"></td>
                            <td className="summary-excel-tab br-5"></td>
                            <td className="summary-excel-tab br-5"></td>
                            <td className="summary-excel-tab br-5"></td>
                            <td className="summary-excel-tab br-5">{selectedLetterTemplate || ""}</td>
                          </tr>
                        );
                      })
                  )
                ) : (
                  <tr>
                    <td className="summary-excel-tab br-5">[emp_code]</td>
                    <td className="summary-excel-tab br-5"></td>
                    <td className="summary-excel-tab br-5"></td>
                    <td className="summary-excel-tab br-5"></td>
                    <td className="summary-excel-tab br-5"></td>
                    <td className="summary-excel-tab br-5"></td>
                    <td className="summary-excel-tab br-5"></td>
                    <td className="summary-excel-tab br-5"></td>
                    <td className="summary-excel-tab br-5"></td>
                    <td className="summary-excel-tab br-5"></td>
                    <td className="summary-excel-tab br-5"></td>
                    <td className="summary-excel-tab br-5"></td>
                    <td className="summary-excel-tab br-5">{selectedLetterTemplate || ""}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="ib-allowed-columns">
            <span className="ib-allowed-columns-title">Allowed Columns In Your Excel</span>
            <div className="ib-chip-row">
              {ALLOWED_COLUMNS.map((col) => (
                <span key={col.key} className={`ib-chip ${col.required ? "ib-chip-required" : "ib-chip-optional"}`}>
                  {col.key}
                  {col.required && <span className="ib-chip-badge">required</span>}
                </span>
              ))}
            </div>
            <p className="ib-warning-text">⚠ Adding any column not listed above will cause an error on upload.</p>
          </div>

          {/* <hr className="field-cont-hr" style={{ margin: "20px 0" }} /> */}

          {/* ---------------- STEP 2 ---------------- */}
          <div className="ib-step-box">
            <span className="ib-step-badge">Step 2</span>
            <p className="ib-step-text">
              Upload your filled Excel template below. Only <b>.xlsx</b> or <b>.xls</b> files are accepted.
            </p>
          </div>

          <label
            htmlFor="document_file"
            className={`ib-dropzone ${dragActive ? "ib-dropzone-active" : ""} ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
              }`}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            <Attachment />
            <p className="ib-dropzone-text">Drop your filled Excel here or click to browse</p>
            <span className="ib-dropzone-subtext">Step 2: Upload your filled template</span>
          </label>
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={handleFileUpload}
            id="document_file"
            name="document_file"
            className="file-inputs align-center"
            style={{ display: "none" }}
          />

          <div className="ib-filename-row">
            {fileName ? (
              <p className=" font-size-text align-center">{fileName}</p>
            ) : (
              <p className="font-size-text align-center ib-filename-placeholder">No file selected</p>
            )}
            {(fileName || jsonData) && (
              <button className="file-clear clear-btn" onClick={handleFileClear}>
                Clear
              </button>
            )}
          </div>
          {docErrors.document_file && (
            <span className="file-name error-message font-size-text">{docErrors.document_file}</span>
          )}

          {validationErrors.length > 0 && (
            <div className="ib-error-box">
              <p className="ib-error-title">⚠ Fix these rows in your Excel and re-upload:</p>
              <ul className="ib-error-list">
                {validationErrors.slice(0, 5).map((err, i) => (
                  <li key={i}>{err}</li>
                ))}
              </ul>
              {validationErrors.length > 5 && (
                <p className="ib-error-more">+{validationErrors.length - 5} more row(s) with missing fields</p>
              )}
            </div>
          )}

          {jsonData && (
            <div className="scroll-container-table">
              <h4>Data to be Uploaded</h4>
              <table className="scrollfix-table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">Emp Code</th>
                    <th className="align-center">WEF Date</th>
                    <th className="align-center">Letter Type</th>
                    <th className="align-center">Previous Grade</th>
                    <th className="align-center">Update Grade</th>
                    <th className="align-center">Old Designation</th>
                    <th className="align-center">Updated Designation</th>
                    <th className="align-center">Existing CTC</th>
                    <th className="align-center">Increment Percentage</th>
                    <th className="align-center">Increment Amount</th>
                    <th className="align-center">Revised CTC</th>
                    <th className="align-center">Authority Signatory</th>
                    <th className="align-center">Uploaded By</th>
                    <th className="align-center">Letter Template</th>
                  </tr>
                </thead>
                <tbody>
                  {jsonData.map((row, index) => (
                    <tr key={index}>
                      <td className="align-left">{row.empcode || "-"}</td>
                      <td className="align-center">{row.wefdate ? formattedDateLong(row.wefdate) : "-"}</td>
                      <td className="align-center">{row.letter_type || "-"}</td>
                      <td className="align-center">{row.previous_grade || "-"}</td>
                      <td className="align-center">{row.update_grade || "-"}</td>
                      <td className="align-center">{row.old_designation || "-"}</td>
                      <td className="align-center">{row.updated_designation || "-"}</td>
                      <td className="align-center">{row.existing_ctc || "-"}</td>
                      <td className="align-center">{row.increment_percentage || "-"}</td>
                      <td className="align-center">{row.increment_amount || "-"}</td>
                      <td className="align-center">{row.revised_ctc || "-"}</td>
                      <td className="align-center">{row.authority_signatory || "-"}</td>
                      <td className="align-center">{row.uploaded_by || "-"}</td>
                      <td className="align-center">{row.letter_template || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <div className="button-models">
            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
              Cancel
            </button>
            <button
              className="model-button-download model-button font-weight500"
              onClick={handleSubmit}
              disabled={loading}
            >
              <UploadIcon /> {"  "}
              {loading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </Modal.Body>

        <ToastContainer
          position="top-center"
          autoClose={10000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};



const TdsCalculationModalBackup = ({ employee }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const {
    emp_code,
    emp_name,
    age,
    regime,
    regime_name,
    gross_income,
    standard_deduction,
    income_after_standard_deduction,
    total_other_income,
    total_deductions,
    taxable_income,
    annual_tax,
    monthly_tds_12,
    monthly_tds_remaining,
    rebate_applied,
    surcharge_applied,
    cess_value,
    cess_percent,
    slabs,
    other_income_details,
    deduction_details,
    months_elapsed,
    months_remaining,
    calculation_date,
    financial_year
  } = employee;

  return (
    <>
      <button
        className="allproject-dashboard"
        title="View TDS Calculation Details"
        onClick={handleShow}
      >
        <Eye />
      </button>

      <Modal show={show} onHide={handleClose} size="xl" dialogClassName="tds-calculation-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            TDS Calculation Details - {emp_name} ({emp_code})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="tds-calculation-container">

            {/* Basic Information */}
            <div className="section-card">
              <h4 className="section-title">Basic Information</h4>
              <div className="info-grid">
                <div className="info-item">
                  <label>Financial Year:</label>
                  <span>{financial_year || '-'}</span>
                </div>
                <div className="info-item">
                  <label>Tax Regime:</label>
                  <span>{regime_name || regime || '-'}</span>
                </div>
                <div className="info-item">
                  <label>Age:</label>
                  <span>{age || '-'} years</span>
                </div>
                <div className="info-item">
                  <label>Calculation Date:</label>
                  <span>{calculation_date ? new Date(calculation_date).toLocaleDateString() : '-'}</span>
                </div>
              </div>
            </div>

            {/* Income Breakdown */}
            <div className="section-card">
              <h4 className="section-title">Income Breakdown</h4>
              <div className="calculation-grid">
                <div className="calculation-row">
                  <span>Gross Annual Salary:</span>
                  <span className="amount">₹{gross_income?.toLocaleString('en-IN') || '0'}</span>
                </div>
                <div className="calculation-row deduction">
                  <span>Less: Standard Deduction:</span>
                  <span className="amount">-₹{standard_deduction?.toLocaleString('en-IN') || '0'}</span>
                </div>
                <div className="calculation-row subtotal">
                  <span>Income from Salary:</span>
                  <span className="amount">₹{income_after_standard_deduction?.toLocaleString('en-IN') || '0'}</span>
                </div>

                {/* Other Incomes */}
                {other_income_details && other_income_details.length > 0 && (
                  <>
                    <div className="calculation-row section-header">
                      <span>Other Incomes:</span>
                    </div>
                    {other_income_details.map((income, index) => (
                      <div key={index} className="calculation-row income">
                        <span className="indented">+ {income.section_name || income.section}:</span>
                        <span className="amount">+₹{income.amount_considered?.toLocaleString('en-IN') || '0'}</span>
                      </div>
                    ))}
                    <div className="calculation-row subtotal">
                      <span>Gross Total Income:</span>
                      <span className="amount">
                        ₹{(income_after_standard_deduction + (total_other_income || 0))?.toLocaleString('en-IN') || '0'}
                      </span>
                    </div>
                  </>
                )}

                {/* Deductions */}
                {deduction_details && deduction_details.length > 0 && (
                  <>
                    <div className="calculation-row section-header">
                      <span>Deductions:</span>
                    </div>
                    {deduction_details.map((deduction, index) => (
                      <div key={index} className="calculation-row deduction">
                        <span className="indented">- {deduction.section_name || deduction.section}:</span>
                        <span className="amount">-₹{deduction.allowed_deduction?.toLocaleString('en-IN') || '0'}</span>
                      </div>
                    ))}
                  </>
                )}

                <div className="calculation-row total">
                  <span>Taxable Income:</span>
                  <span className="amount">₹{taxable_income?.toLocaleString('en-IN') || '0'}</span>
                </div>
              </div>
            </div>

            {/* Tax Calculation */}
            <div className="section-card">
              <h4 className="section-title">Tax Calculation</h4>

              {/* Tax Slabs */}
              {slabs && slabs.length > 0 && (
                <div className="slabs-section">
                  <h5>Tax Slabs Breakdown:</h5>
                  <table className="slabs-table">
                    <thead>
                      <tr>
                        <th>Slab Range</th>
                        <th>Rate</th>
                        <th>Income in Slab</th>
                        <th>Tax Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {slabs.map((slab, index) => (
                        <tr key={index}>
                          <td>
                            ₹{slab.min_income?.toLocaleString('en-IN') || '0'} -
                            ₹{slab.max_income ? slab.max_income.toLocaleString('en-IN') : '∞'}
                          </td>
                          <td>{slab.rate}%</td>
                          <td>₹{slab.slab_income?.toLocaleString('en-IN') || '0'}</td>
                          <td>₹{slab.slab_tax?.toLocaleString('en-IN') || '0'}</td>
                        </tr>
                      ))}
                      <tr className="slab-total">
                        <td colSpan="2"><strong>Total</strong></td>
                        <td>
                          <strong>
                            ₹{slabs.reduce((sum, slab) => sum + (slab.slab_income || 0), 0).toLocaleString('en-IN')}
                          </strong>
                        </td>
                        <td>
                          <strong>
                            ₹{slabs.reduce((sum, slab) => sum + (slab.slab_tax || 0), 0).toLocaleString('en-IN')}
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* Additional Tax Components */}
              <div className="tax-components">
                <div className="calculation-row">
                  <span>Tax before Rebate & Cess:</span>
                  <span className="amount">₹{slabs?.reduce((sum, slab) => sum + (slab.slab_tax || 0), 0)?.toLocaleString('en-IN') || '0'}</span>
                </div>

                {rebate_applied > 0 && (
                  <div className="calculation-row deduction">
                    <span>Less: Rebate u/s 87A:</span>
                    <span className="amount">-₹{rebate_applied?.toLocaleString('en-IN') || '0'}</span>
                  </div>
                )}

                {surcharge_applied > 0 && (
                  <div className="calculation-row">
                    <span>Add: Surcharge:</span>
                    <span className="amount">+₹{surcharge_applied?.toLocaleString('en-IN') || '0'}</span>
                  </div>
                )}

                {cess_value > 0 && (
                  <div className="calculation-row">
                    <span>Add: Health & Education Cess ({cess_percent}%):</span>
                    <span className="amount">+₹{cess_value?.toLocaleString('en-IN') || '0'}</span>
                  </div>
                )}

                <div className="calculation-row total-tax">
                  <span><strong>Total Annual Tax:</strong></span>
                  <span className="amount"><strong>₹{annual_tax?.toLocaleString('en-IN') || '0'}</strong></span>
                </div>
              </div>
            </div>

            {/* TDS Summary */}
            <div className="section-card">
              <h4 className="section-title">TDS Summary</h4>
              <div className="tds-summary">
                <div className="tds-item">
                  <label>Monthly TDS (Equal 12 months):</label>
                  <span className="amount">₹{monthly_tds_12?.toLocaleString('en-IN') || '0'}</span>
                </div>
                <div className="tds-item">
                  <label>Monthly TDS (Remaining {months_remaining} months):</label>
                  <span className="amount">₹{monthly_tds_remaining?.toLocaleString('en-IN') || '0'}</span>
                </div>
                <div className="tds-item">
                  <label>Months Elapsed (Apr to Now):</label>
                  <span>{months_elapsed || '0'}</span>
                </div>
                <div className="tds-item">
                  <label>Months Remaining:</label>
                  <span>{months_remaining || '0'}</span>
                </div>
              </div>
            </div>

          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};


const TdsCalculationModalBackup1 = ({ employee }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const {
    emp_code,
    emp_name,
    age,
    regime,
    gross_salary,
    gross_total_income_from_salary,
    standard_deduction,
    annual_gross_salary,
    total_income,
    taxable_income,
    annual_tax,
    monthly_tds_12,
    monthly_tds_remaining,
    rebate_applied,
    surcharge_applied,
    cess_value,
    cess_percent,
    slabs = [],
    deductions = [],
    other_income_details = [],
    calculation_date,
    financial_year
  } = employee;

  // Calculate totals
  const totalOtherIncome = other_income_details?.reduce((sum, income) => sum + (income.declared || 0), 0) || 0;
  const totalDeductions = deductions?.reduce((sum, deduction) => sum + (deduction.allowed || 0), 0) || 0;
  const totalSlabTax = slabs?.reduce((sum, slab) => sum + (slab.slab_tax || 0), 0) || 0;

  return (
    <>
      <button
        className="allproject-dashboard"
        title="View TDS Calculation Details"
        onClick={handleShow}
      >
        <Eye />
      </button>

      <Modal show={show} onHide={handleClose} size="xl" dialogClassName="tds-calculation-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            TDS Calculation Details - {emp_name} ({emp_code})
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="tds-calculation-container">

            {/* Basic Information */}
            <div className="section-card">
              <h4 className="section-title">Basic Information</h4>
              <div className="info-grid">
                <div className="info-item">
                  <label>Financial Year:</label>
                  <span>{financial_year || '-'}</span>
                </div>
                <div className="info-item">
                  <label>Tax Regime:</label>
                  <span>{regime || '-'}</span>
                </div>
                <div className="info-item">
                  <label>Age:</label>
                  <span>{age || '-'} years</span>
                </div>
                <div className="info-item">
                  <label>Calculation Date:</label>
                  <span>{calculation_date ? new Date(calculation_date).toLocaleDateString() : '-'}</span>
                </div>
              </div>
            </div>

            {/* Income Breakdown */}
            <div className="section-card">
              <h4 className="section-title">Income Breakdown</h4>
              <div className="calculation-grid">
                <div className="calculation-row">
                  <span>Gross Annual Salary:</span>
                  <span className="amount">₹{annual_gross_salary?.toLocaleString('en-IN') || '0'}</span>
                </div>
                <div className="calculation-row deduction">
                  <span>Less: Standard Deduction:</span>
                  <span className="amount">-₹{standard_deduction?.toLocaleString('en-IN') || '0'}</span>
                </div>
                <div className="calculation-row subtotal">
                  <span>Gross Total Income from Salary:</span>
                  <span className="amount">₹{gross_total_income_from_salary?.toLocaleString('en-IN') || '0'}</span>
                </div>

                {/* Other Incomes */}
                {other_income_details && other_income_details.length > 0 && (
                  <>
                    <div className="calculation-row section-header">
                      <span>Other Incomes:</span>
                    </div>
                    {other_income_details.map((income, index) => (
                      <div key={index} className="calculation-row income">
                        <span className="indented">+ {income.section}:</span>
                        <span className="amount">+₹{income.declared?.toLocaleString('en-IN') || '0'}</span>
                      </div>
                    ))}
                    <div className="calculation-row subtotal">
                      <span>Total Income:</span>
                      <span className="amount">₹{total_income?.toLocaleString('en-IN') || '0'}</span>
                    </div>
                  </>
                )}

                {/* Deductions */}
                {deductions && deductions.length > 0 && (
                  <>
                    <div className="calculation-row section-header">
                      <span>Deductions:</span>
                    </div>
                    {deductions.map((deduction, index) => (
                      <div key={index} className="calculation-row deduction">
                        <span className="indented">- {deduction.section}:</span>
                        <span className="amount">-₹{deduction.allowed?.toLocaleString('en-IN') || '0'}</span>
                      </div>
                    ))}
                    <div className="calculation-row subtotal">
                      <span>Income After Deductions:</span>
                      <span className="amount">₹{(deductions[deductions.length - 1]?.income_after_deduction || taxable_income)?.toLocaleString('en-IN') || '0'}</span>
                    </div>
                  </>
                )}

                <div className="calculation-row total">
                  <span>Taxable Income:</span>
                  <span className="amount">₹{taxable_income?.toLocaleString('en-IN') || '0'}</span>
                </div>
              </div>
            </div>

            {/* Tax Calculation */}
            <div className="section-card">
              <h4 className="section-title">Tax Calculation</h4>

              {/* Tax Slabs */}
              {slabs && slabs.length > 0 && (
                <div className="slabs-section">
                  <h5>Tax Slabs Breakdown:</h5>
                  <table className="slabs-table">
                    <thead>
                      <tr>
                        <th>Slab Range</th>
                        <th>Rate</th>
                        <th>Income in Slab</th>
                        <th>Tax Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      {slabs.map((slab, index) => (
                        <tr key={index}>
                          <td>
                            ₹{slab.min_income?.toLocaleString('en-IN') || '0'} -
                            ₹{slab.max_income ? slab.max_income.toLocaleString('en-IN') : '∞'}
                          </td>
                          <td>{slab.rate}%</td>
                          <td>₹{slab.slab_income?.toLocaleString('en-IN') || '0'}</td>
                          <td>₹{slab.slab_tax?.toLocaleString('en-IN') || '0'}</td>
                        </tr>
                      ))}
                      <tr className="slab-total">
                        <td colSpan="2"><strong>Total</strong></td>
                        <td>
                          <strong>₹{slabs.reduce((sum, slab) => sum + (slab.slab_income || 0), 0).toLocaleString('en-IN')}</strong>
                        </td>
                        <td>
                          <strong>₹{totalSlabTax.toLocaleString('en-IN')}</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* Additional Tax Components */}
              <div className="tax-components">
                <div className="calculation-row">
                  <span>Tax before Rebate & Cess:</span>
                  <span className="amount">₹{totalSlabTax.toLocaleString('en-IN')}</span>
                </div>

                {rebate_applied > 0 && (
                  <div className="calculation-row deduction">
                    <span>Less: Rebate u/s 87A:</span>
                    <span className="amount">-₹{rebate_applied?.toLocaleString('en-IN') || '0'}</span>
                  </div>
                )}

                {surcharge_applied > 0 && (
                  <div className="calculation-row">
                    <span>Add: Surcharge:</span>
                    <span className="amount">+₹{surcharge_applied?.toLocaleString('en-IN') || '0'}</span>
                  </div>
                )}

                {cess_value > 0 && (
                  <div className="calculation-row">
                    <span>Add: Health & Education Cess ({cess_percent || 4}%):</span>
                    <span className="amount">+₹{cess_value?.toLocaleString('en-IN') || '0'}</span>
                  </div>
                )}

                <div className="calculation-row total-tax">
                  <span><strong>Total Annual Tax:</strong></span>
                  <span className="amount"><strong>₹{annual_tax?.toLocaleString('en-IN') || '0'}</strong></span>
                </div>
              </div>
            </div>

            {/* TDS Summary */}
            <div className="section-card">
              <h4 className="section-title">TDS Summary</h4>
              <div className="tds-summary">
                <div className="tds-item">
                  <label>Monthly TDS (Equal 12 months):</label>
                  <span className="amount">₹{monthly_tds_12?.toLocaleString('en-IN') || '0'}</span>
                </div>
                <div className="tds-item">
                  <label>Monthly TDS (Remaining months):</label>
                  <span className="amount">₹{monthly_tds_remaining?.toLocaleString('en-IN') || '0'}</span>
                </div>
                <div className="tds-item">
                  <label>Total Other Incomes:</label>
                  <span className="amount">₹{totalOtherIncome.toLocaleString('en-IN')}</span>
                </div>
                <div className="tds-item">
                  <label>Total Deductions:</label>
                  <span className="amount">₹{totalDeductions.toLocaleString('en-IN')}</span>
                </div>
              </div>
            </div>

            {/* Detailed Breakdown Sections */}
            {/* Other Incomes Details */}
            {other_income_details && other_income_details.length > 0 && (
              <div className="section-card">
                <h4 className="section-title">Other Income Details</h4>
                <table className="details-table">
                  <thead>
                    <tr>
                      <th>Section</th>
                      <th>Declared Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {other_income_details.map((income, index) => (
                      <tr key={index}>
                        <td>{income.section}</td>
                        <td>₹{income.declared?.toLocaleString('en-IN') || '0'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* Deductions Details */}
            {deductions && deductions.length > 0 && (
              <div className="section-card">
                <h4 className="section-title">Deduction Details</h4>
                <table className="slabs-table">
                  <thead>
                    <tr>
                      <th>Section</th>
                      <th>Declared</th>
                      <th>Allowed</th>
                      <th>Income After Deduction</th>
                    </tr>
                  </thead>
                  <tbody>
                    {deductions.map((deduction, index) => (
                      <tr key={index}>
                        <td>{deduction.section}</td>
                        <td>₹{deduction.declared?.toLocaleString('en-IN') || '0'}</td>
                        <td>₹{deduction.allowed?.toLocaleString('en-IN') || '0'}</td>
                        <td>₹{deduction.income_after_deduction?.toLocaleString('en-IN') || '0'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};


const TdsCalculationModal = ({ employee }) => {
  console.log(employee, "emp");


  const [show, setShow] = useState(false);
  const [investmentSelection, setInvestmentSelection] = useState('declaration')
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // -------------------------destructure whole employee data at once
  const {
    emp_code,
    emp_name,
    age,
    regime,
    regime_name,
    calculation_period,
    monthly_gross_salary,
    annual_gross_salary,
    income_calculation_method,
    income_calculation_heading,
    standard_deduction,
    gross_total_income_from_salary,
    income_after_standard_deduction,
    other_income_details = [],
    other_investment_details = [],
    total_declared_investment,
    total_declared_income,
    total_prooved_investment,
    total_income,
    total_income_after_other_incomes,
    less_deduction,
    taxable_income,
    slabs = [],
    rebate_applied,
    annual_tax,
    monthly_tds_12,
    monthly_tds_remaining,
    surcharge_applied,
    cess_value,
    cess_percent,
    calculation_date,
    financial_year,
    taxable_declared,
    declared_slab_tax_raw,
    annual_tax_declared,
    monthly_tds_12_declared,
    monthly_tds_remaining_declared,
    total_allowed_declared_deduction,
    slab_breakdown,
    regime_fy_start,
    regime_fy_end,
    declared_total_income_after_other_incomes,
    surcharge_amount_declared_adj,
    cess_amount_declared_adj,
    salary_type_used_for_calculation,
    arrear_details,
    gross_income_calculation_heading,
    gross_income_calculation_method,

    total_investment,

    declared_total_income,
    declared_total_investment,
    saved_status,
    saved_data,
    monthly_adjustment,

    slab_tax_raw,
    surcharge_amount,
    cess_amount,
    other_Income_summary,
    other_Investment_summary,

  } = employee;

  // -----------------------------data for declaration data
  const declarationData = {
    emp_code,
    emp_name,
    age,
    regime,
    regime_name,
    calculation_period,
    monthly_gross_salary,
    annual_gross_salary,
    income_calculation_method,
    income_calculation_heading,
    standard_deduction,
    gross_total_income_from_salary,
    income_after_standard_deduction,
    other_income_details,
    other_investment_details,
    total_declared_investment,
    total_declared_income,
    total_prooved_investment,
    total_income,
    total_income_after_other_incomes,
    less_deduction,
    taxable_income,
    slabs,
    rebate_applied,
    annual_tax,
    monthly_tds_12,
    monthly_tds_remaining,
    surcharge_applied,
    cess_value,
    cess_percent,
    calculation_date,
    financial_year,
    taxable_declared,
    declared_slab_tax_raw,
    annual_tax_declared,
    monthly_tds_12_declared,
    monthly_tds_remaining_declared,
    total_allowed_declared_deduction,
    slab_breakdown,
    regime_fy_start,
    regime_fy_end,
    declared_total_income_after_other_incomes,
    surcharge_amount_declared_adj,
    cess_amount_declared_adj,
    salary_type_used_for_calculation,
    arrear_details,
    gross_income_calculation_heading,
    gross_income_calculation_method,
    total_investment,

    declared_total_income,
    declared_total_investment,
    saved_status,
    saved_data,
    monthly_adjustment,

    slab_tax_raw,
    surcharge_amount,
    cess_amount,
    other_Income_summary,
    other_Investment_summary,
  };





  return (
    <>
      <ButtonVariants
        buttonDisplay={'Eye'}
        buttonDisplayName={'View Details'}
        buttonDisplayTitle={'View TDS Calculation Details'}
        handleShow={handleShow}
      />

      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        dialogClassName="tds-calculation-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {investmentSelection === "declaration" ? "TDS Breakdown - Declared Investment" : "TDS Breakdown - Verified Proof"}
          </Modal.Title>

        </Modal.Header>
        <Modal.Body>

          <div className="button-models flex-column">
            {/* ---------------------------------Toggle Structure */}
            {/* <div className="leave-duration-tabs" style={{ width: "96%", position: "relative", display: "flex", marginBottom: "15px" }}>
              <input
                type="radio"
                id="investment-declaration"
                name="investmentType"
                value="declaration"
                checked={investmentSelection === "declaration"}
                onChange={(e) => setInvestmentSelection(e.target.value)}
                hidden
              />
              <label htmlFor="investment-declaration" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
                Declaration
              </label>

              <input
                type="radio"
                id="investment-proof"
                name="investmentType"
                value="proof"
                checked={investmentSelection === "proof"}
                onChange={(e) => setInvestmentSelection(e.target.value)}
                hidden
              />
              <label htmlFor="investment-proof" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
                Proof
              </label>

              <span
                className="leave-tab-glider"
                style={{
                  transform: investmentSelection === "declaration" ? "translateX(0%)" : "translateX(100%)",
                  width: "50%"
                }}
              ></span>
            </div> */}
            {/* ---------------------------------Investment Declaration Tds data */}
            {/* {investmentSelection === "declaration" && ( */}
            <InvestmentDeclarationTdsData data={declarationData} />
            {/* )} */}
            {/* ---------------------------------Investment Proof tds data */}
            {/* {investmentSelection === "proof" && (
              <InvestmentProofTdsData data={proofData} />
            )} */}
            {/* ----------------------------------Buttons */}
            <div className='width100 button-models'>
              <button type="button"
                className="model-button model-button-cancel font-weight500"
                style={{ padding: '13px 38px' }}
                onClick={handleClose}>
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

// const TdsCalculationModalForTDS = ({ employee }) => {
//   console.log(employee, "emp");


//   const [show, setShow] = useState(false);
//   const [investmentSelection, setInvestmentSelection] = useState('declaration')
//   const handleClose = () => setShow(false);
//   const handleShow = () => setShow(true);

//   const { employee_details, current_tax_calculation
//   } = employee;

//   const proofDetails = current_tax_calculation?.proof_tax_details;
//   const hasProofData =
//     proofDetails &&
//     typeof proofDetails === "object" &&
//     Object.keys(proofDetails).length > 0;

//   useEffect(() => {
//     if (!hasProofData) {
//       setInvestmentSelection("declaration");
//     }
//   }, [hasProofData]);


//   return (
//     <>
//       <ButtonVariants
//         buttonDisplay={'Eye'}
//         buttonDisplayName={'View Details'}
//         buttonDisplayTitle={'View TDS Calculation Details'}
//         handleShow={handleShow}
//       />

//       <Modal
//         show={show}
//         onHide={handleClose}
//         size="xl"
//         dialogClassName="tds-calculation-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {investmentSelection === "declaration" ? "TDS Breakdown - Declared Investment" : "TDS Breakdown - Verified Proof"}
//           </Modal.Title>

//         </Modal.Header>
//         <Modal.Body>

//           <div className="button-models flex-column">
//             {/* ---------------------------------Toggle Structure */}
//             {hasProofData && (


//               <div className="leave-duration-tabs" style={{ width: "96%", position: "relative", display: "flex", marginBottom: "15px" }}>
//                 <input
//                   type="radio"
//                   id="investment-declaration"
//                   name="investmentType"
//                   value="declaration"
//                   checked={investmentSelection === "declaration"}
//                   onChange={(e) => setInvestmentSelection(e.target.value)}
//                   hidden
//                 />
//                 <label htmlFor="investment-declaration" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
//                   Declaration
//                 </label>

//                 <input
//                   type="radio"
//                   id="investment-proof"
//                   name="investmentType"
//                   value="proof"
//                   checked={investmentSelection === "proof"}
//                   onChange={(e) => setInvestmentSelection(e.target.value)}
//                   hidden
//                 />
//                 <label htmlFor="investment-proof" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
//                   Proof
//                 </label>

//                 <span
//                   className="leave-tab-glider"
//                   style={{
//                     transform: investmentSelection === "declaration" ? "translateX(0%)" : "translateX(100%)",
//                     width: "50%"
//                   }}
//                 ></span>
//               </div>
//             )}
//             {/* ---------------------------------Investment Declaration Tds data */}
//             {investmentSelection === "declaration" && (
//               <InvestmentDeclarationTdsDataForTdsTable empDetails={employee_details} currenttaxData={current_tax_calculation} />
//             )}
//             {/* ---------------------------------Investment Proof tds data */}
//             {hasProofData && investmentSelection === "proof" && (
//               <InvestmentProofTdsData data={proofDetails} />
//             )}
//             {/* ----------------------------------Buttons */}
//             <div className='width100 button-models'>
//               <button type="button"
//                 className="model-button model-button-cancel font-weight500"
//                 style={{ padding: '13px 38px' }}
//                 onClick={handleClose}>
//                 Cancel
//               </button>
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

const TdsCalculationModalForTDS = ({ employeeDetails, taxData }) => {

  const [show, setShow] = useState(false);

  const [investmentSelection, setInvestmentSelection] = useState("declaration");
  const proofDetails = taxData?.proof_tax_details;
  const hasProofData =
    proofDetails &&
    typeof proofDetails === "object" &&
    Object.keys(proofDetails).length > 0;

  const activeMode = hasProofData ? investmentSelection : "declaration";

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showOtherDetails, setShowOtherDetails] = useState(false);

  // If no proof data, always show declaration
  useEffect(() => {
    if (!hasProofData) {
      setInvestmentSelection("declaration");
    }
  }, [hasProofData]);

  const CalculationTaxDetails = taxData?.calculation_tax_details;

  const handleOpenOtherDetails = () => setShowOtherDetails(true);
  const handleCloseOtherDetails = () => setShowOtherDetails(false);



  return (
    <>
      <ButtonVariants
        buttonDisplay={"Eye"}
        buttonDisplayName={"View Details"}
        buttonDisplayTitle={"View TDS Calculation Details"}
        handleShow={handleShow}
      />

      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        dialogClassName="tds-calculation-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {activeMode === "declaration"
              ? "TDS Breakdown - Declared Investment"
              : "TDS Breakdown - Verified Proof"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="button-models flex-column">
            {/* Toggle Structure */}
            {hasProofData && (
              <div
                className="leave-duration-tabs"
                style={{
                  width: "96%",
                  position: "relative",
                  display: "flex",
                  marginBottom: "15px",
                }}
              >
                <input
                  type="radio"
                  id="investment-declaration"
                  name={`investmentType-${employeeDetails?.emp_code}`} // unique name
                  value="declaration"
                  checked={investmentSelection === "declaration"}
                  onChange={(e) => setInvestmentSelection(e.target.value)}
                  hidden
                />
                <label
                  htmlFor="investment-declaration"
                  className="leave-tab"
                  style={{ flex: 1, textAlign: "center" }}
                >
                  Declaration
                </label>

                <input
                  type="radio"
                  id="investment-proof"
                  name={`investmentType-${employeeDetails?.emp_code}`}
                  value="proof"
                  checked={investmentSelection === "proof"}
                  onChange={(e) => setInvestmentSelection(e.target.value)}
                  hidden
                />
                <label
                  htmlFor="investment-proof"
                  className="leave-tab"
                  style={{ flex: 1, textAlign: "center" }}
                >
                  Proof
                </label>

                <span
                  className="leave-tab-glider"
                  style={{
                    transform:
                      investmentSelection === "declaration"
                        ? "translateX(0%)"
                        : "translateX(100%)",
                    width: "50%",
                  }}
                ></span>
              </div>
            )}

            {/* Investment Declaration TDS data */}
            {/* {investmentSelection === "declaration" && (
              <InvestmentDeclarationTdsDataForTdsTable
                empDetails={employeeDetails}
                currenttaxData={taxData}
              />
            )} */}

            {/* Investment Proof TDS data */}
            {/* {hasProofData && investmentSelection === "proof" && (
              <InvestmentDeclarationTdsDataForTdsTable empDetails={employeeDetails} currenttaxData={taxData} />
            )} */}
            <InvestmentDeclarationTdsDataForTdsTable
              empDetails={employeeDetails}
              currenttaxData={taxData}
              mode={activeMode}
            />


            {(
              (taxData?.calculation_tax_details?.previous_employment_details?.prev_company_salary ?? 0) > 0 ||
              (taxData?.calculation_tax_details?.previous_employment_details?.prev_company_tax ?? 0) > 0
            ) && (
                <div className="section-card" style={{ margin: '0px 10px 10px 10px' }}>
                  <h4 className="section-title">Previous Company Details</h4>

                  <div className="tds-summary">
                    {(taxData?.calculation_tax_details?.previous_employment_details?.prev_company_salary ?? 0) > 0 && (
                      <div className="tds-item">
                        <label>Previous Company Salary:</label>
                        <span className="amount">
                          ₹{taxData?.calculation_tax_details?.previous_employment_details?.prev_company_salary.toLocaleString("en-IN")}
                        </span>
                      </div>
                    )}

                    {(taxData?.calculation_tax_details?.previous_employment_details?.prev_company_tax ?? 0) > 0 && (
                      <div className="tds-item">
                        <label>Previous Company Tax:</label>
                        <span className="amount">
                          ₹{taxData?.calculation_tax_details?.previous_employment_details?.prev_company_tax.toLocaleString("en-IN")}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}

            <div className="section-card" style={{ margin: '0px 10px 10px 10px' }}>
              <h4 className="section-title">Adjustment Months Detail</h4>

              <div className="tds-summary">



                <div className="adjustment-grid">

                  <div className="adjustment-card">
                    <label className='font-size-subheading mb-1'>Tax Comparison</label>
                    <p>Declared Tax <span>₹{CalculationTaxDetails?.annual_tax_declared?.toLocaleString("en-IN")}</span></p>
                    <p>After Proofs <span>₹{CalculationTaxDetails?.annual_tax_proof?.toLocaleString("en-IN")}</span></p>
                    <p className="negative">
                      Difference <span>-₹{Math.abs(CalculationTaxDetails?.annual_tax_difference)?.toLocaleString("en-IN")}</span>
                    </p>
                  </div>

                  <div className="adjustment-card">
                    <label className='font-size-subheading mb-1'>Adjustment Period</label>
                    <p>From <span>{getMonthYearNameFromDate(CalculationTaxDetails?.adjustment_month_start)}</span></p>
                    <p>To <span>{getMonthYearNameFromDate(CalculationTaxDetails?.adjustment_month_end)}</span></p>
                    <p>Remaining Months <span>{CalculationTaxDetails?.adjustment_months_remaining}</span></p>
                  </div>

                  <div className="adjustment-card highlight">
                    <label className='font-size-subheading mb-1'>Final Monthly TDS</label>
                    <div className="big-amount">
                      ₹{CalculationTaxDetails?.final_monthly_tds_after_adjustment_from_proof?.toLocaleString("en-IN")}
                    </div>
                    <small>Applicable during adjustment period</small>
                  </div>

                </div>



              </div>
            </div>

            <div className="section-card" style={{ margin: '0px 10px 10px 10px' }}>
              <h4 className="section-title">Arrears Summary</h4>

              <div className="arrear-summary">
                <div>
                  <label className='font-size-subheading'>Current Arrears : </label>
                  <span className='amount ms-1'>₹{CalculationTaxDetails?.current_arrear_details
                    ?.total_arrear_amount.toLocaleString("en-IN")}</span>
                </div>
                <div>
                  <label className="font-size-subheading">
                    Total Arrears ({CalculationTaxDetails?.arrear_details_summary?.arrear_count ?? 0}) :
                  </label>
                  <span className='amount ms-1'>₹{CalculationTaxDetails?.arrear_details_summary?.total_arrear_amount.toLocaleString("en-IN")}</span>
                </div>

                <ButtonVariants
                  buttonDisplay={'Eye'}
                  buttonDisplayName={'Arrear Details'}
                  buttonDisplayTitle={'View Details related to Arrear'}
                  handleShow={handleOpenOtherDetails}
                />
              </div>
            </div>




            {/* Buttons */}
            <div className="width100 button-models">
              <button
                type="button"
                className="model-button model-button-cancel font-weight500"
                style={{ padding: "13px 38px" }}
                onClick={handleClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* --------------------------Display other details like Arrear & Previuos company details */}
      <Modal show={showOtherDetails} onHide={handleCloseOtherDetails} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Arrear Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="arrear-list">
            {CalculationTaxDetails?.arrear_details_summary.annual_arrear_details.map((arrear, index) => {
              const arrearReq = arrear?.arrear_details?.arrear_request_details?.request_details || {};

              const natureType = arrear?.nature_type;

              const dateList = arrearReq?.date_list || [];

              const formattedDatesArray = dateList.length > 0 ? dateList.map(d => formatDate(d)) : [];

              const truncatedDateList =
                formattedDatesArray.length > 3
                  ? `${formattedDatesArray.slice(0, 3).join(", ")} ...`
                  : formattedDatesArray.join(", ");

              const fullDateListTooltip = (
                <div className="font-size-text">
                  {formattedDatesArray.map((date, index) => (
                    <div key={index}>{date}</div>
                  ))}
                </div>
              );

              return (
                <details key={index} className="arrear-card">
                  <summary className="arrear-header">
                    <span className='flex-column padding_ text-warning-color notice-badge'>
                      {getMonthName(arrear.applicable_month)} {arrear.applicable_year}
                    </span>

                    <span className='text-capitalize flex-column'>{arrear.nature_type} based Arrear</span>

                    <span request-status={arrear?.status} className='request-status flex-column text-capitalize'>
                      {arrear?.status}
                    </span>
                    {/* Arrow */}
                    <span className="details-arrow" aria-hidden>
                      <DropdownArrowOption />
                    </span>
                  </summary>

                  <div className="tds-item">
                    <div className="arrear-body">
                      <div>
                        <p className='text-capitalize'><strong>Nature:</strong> {natureType}</p>
                        <p>
                          <strong>Applicable Month:</strong>{" "}
                          {getMonthName(arrear.applicable_month)} {arrear.applicable_year}
                        </p>

                        {(natureType === "days" || natureType === "months") ? (
                          <p><strong>Approved Days:</strong> {arrear.approved_days}</p>
                        ) : (
                          <p>
                            <strong>Approved Amount:</strong>{" "}
                            ₹{arrear.approved_amount?.toLocaleString("en-IN")}
                          </p>
                        )}
                        <div>
                          <p style={{ marginBottom: '0px' }}><strong>Reason:</strong></p>
                          {arrear.reason}
                        </div>
                      </div>

                      <div className="right">
                        <p>
                          <strong>Calculated Amount:</strong>{" "}
                          ₹{arrear.calculated_amount?.toLocaleString("en-IN")}
                        </p>

                        <p>
                          <strong>Status:</strong>{" "}
                          <span className="text-capitalize">{arrear.status}</span>
                        </p>

                        {/* DAYS BASED – Date list with tooltip */}
                        {natureType === "days" && (
                          <div>
                            <strong>Dates:</strong>{" "}
                            {formattedDatesArray.length > 3 ? (
                              <CustomTooltip position="top" tooltipContent={fullDateListTooltip}>
                                <span
                                  style={{
                                    cursor: "help",
                                    textDecoration: "underline dotted",
                                  }}
                                >
                                  {truncatedDateList}
                                </span>
                              </CustomTooltip>
                            ) : (
                              truncatedDateList || "-"
                            )}
                          </div>
                        )}

                        {/* MONTHS BASED */}
                        {natureType === "months" && (
                          <div >
                            <strong>Period:</strong>{" "}
                            {formatDate(arrearReq?.start_date)} to{" "}
                            {formatDate(arrearReq?.end_date)}
                          </div>
                        )}


                      </div>
                    </div>

                  </div>
                </details>
              )
            })}
          </div>

        </Modal.Body>
      </Modal>
    </>
  );
};


const InvestmentDeclarationTdsData = ({ data }) => {
  const [showOtherDetails, setShowOtherDetails] = useState(false);

  const [showInvestDetails, setShowInvestDetails] = useState(false);
  const [showIncomeDetails, setShowIncomeDetails] = useState(false);

  const handleShowInvestDetails = () => setShowInvestDetails(true);
  const handleShowIncomeDetails = () => setShowIncomeDetails(true);
  const handleCloseIncomeDetails = () => setShowIncomeDetails(false);

  const handleCloseInvestDetails = () => setShowInvestDetails(false);


  const handleOpenOtherDetails = () => setShowOtherDetails(true);
  const handleCloseOtherDetails = () => setShowOtherDetails(false);

  const {
    emp_code,
    emp_name,
    age,
    regime,
    regime_name,
    calculation_period,
    monthly_gross_salary,
    annual_gross_salary,
    income_calculation_method,
    income_calculation_heading,
    standard_deduction,
    gross_total_income_from_salary,
    income_after_standard_deduction,
    other_income_details,
    other_investment_details,
    total_declared_investment,
    total_declared_income,
    total_prooved_investment,
    total_income,
    total_income_after_other_incomes,
    less_deduction,
    taxable_income,
    slabs,
    rebate_applied,
    annual_tax,
    monthly_tds_12,
    monthly_tds_remaining,
    surcharge_applied,
    cess_value,
    cess_percent,
    calculation_date,
    financial_year,
    taxable_declared,
    declared_slab_tax_raw,
    annual_tax_declared,
    monthly_tds_12_declared,
    monthly_tds_remaining_declared,
    total_allowed_declared_deduction,
    slab_breakdown,
    regime_fy_start,
    regime_fy_end,
    declared_total_income_after_other_incomes,
    surcharge_amount_declared_adj,
    cess_amount_declared_adj,
    salary_type_used_for_calculation,
    arrear_details,
    gross_income_calculation_heading,
    gross_income_calculation_method,
  } = data;

  // Totals
  // const natureType =
  //   arrear_details?.arrear_request_details?.nature_type || "";

  // const approvedLabel =
  //   natureType === "days"
  //     ? "Approved Days"
  //     : natureType === "months"
  //       ? "Approved Months"
  //       : "Approved Amount";

  // const approvedValue =
  //   natureType === "amount"
  //     ? arrear_details?.arrear_request_details?.approved_amount
  //     : arrear_details?.arrear_request_details?.approved_days;

  const arrearReq = arrear_details?.arrear_request_details?.request_details;
  const natureType = arrearReq?.nature_type;


  const formattedDatesArray =
    arrearReq?.date_list?.length > 0
      ? arrearReq.date_list.map(date => formatDateTime(date))
      : [];

  const truncatedDateList =
    formattedDatesArray.length > 3
      ? `${formattedDatesArray.slice(0, 3).join(", ")} ...`
      : formattedDatesArray.join(", ");

  const fullDateListTooltip = (
    <div className='font-size-text'>
      {formattedDatesArray.map((date, index) => (
        <div key={index}>{date}</div>
      ))}
    </div>
  );


  const totalOtherIncome =
    other_income_details?.reduce(
      (sum, income) => sum + (income.declared_amount || 0),
      0
    ) || 0;

  const totalInvestmentsAllowed =
    other_investment_details?.reduce(
      (sum, d) => sum + (d.allowed_declared || 0),
      0
    ) || 0;

  const totalSlabTax =
    slabs?.reduce((sum, slab) => sum + (slab.slab_tax_amount || 0), 0) || 0;



  const getSlabBreakdownText = (slab, index, slab_breakdown, taxable_income) => {
    let remaining = taxable_income;


    for (let i = 0; i < index; i++) {
      remaining -= slab_breakdown[i].taxable_amount;
    }
    let rangeLimit;
    if (slab.max_income) {
      rangeLimit = slab.max_income - slab.min_income;
    } else {

      rangeLimit = remaining;
    }


    if (isNaN(rangeLimit)) rangeLimit = remaining;
    // const rangeLimit = slab.max_income ? slab.max_income - slab.min_income : remaining || 0;

    const usedAmount = slab.taxable_amount;
    const afterThis = remaining - usedAmount;

    return (
      <div style={{ padding: "10px", fontSize: "13px", minWidth: "260px" }}>
        {/* <div><strong>Slab Range:</strong> {slab.min_income.toLocaleString("en-IN")} - {slab.max_income ? slab.max_income.toLocaleString("en-IN") : "∞"}</div> */}

        <div style={{ marginTop: "8px" }}>
          <strong>Starting Balance:</strong><br />
          ₹{remaining?.toLocaleString("en-IN")}
        </div>

        <div style={{ marginTop: "8px" }}>
          <strong>Slab Deduction Limit:</strong><br />
          ₹{rangeLimit?.toLocaleString("en-IN")}
        </div>

        <div style={{ marginTop: "8px", color: "red" }}>
          <strong>Income Deducted in Slab:</strong><br />
          ₹{usedAmount?.toLocaleString("en-IN")}
        </div>

        <hr style={{ margin: "8px 0" }} />

        <div>
          <strong>Remaining After This Slab:</strong><br />
          ₹{afterThis?.toLocaleString("en-IN")}
        </div>
      </div>
    );
  };

  const renderDeclaredTooltip = (inv) => {
    return (
      <div
        style={{
          padding: "12px",
          fontSize: "13px",
          lineHeight: "1.8",
          minWidth: "260px",

        }}
      >

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Declared Amount</span>
          <strong>
            ₹{inv.declared_amount_original?.toLocaleString("en-IN") || "0"}
          </strong>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Max Limit</span>
          <strong>
            ₹{inv.max_limit?.toLocaleString("en-IN") || "0"}
          </strong>
        </div>


        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Allowed Amount</span>
          <strong style={{ color: "#1bae3d" }}>
            ₹{inv.allowed_declared?.toLocaleString("en-IN") || "0"}
          </strong>
        </div>
      </div>
    );
  };
  return (
    <>
      <div className="tds-calculation-container">
        {/* --------------------------------------BASIC INFO */}
        <div className="section-card">
          <h4 className="section-title">Basic Information</h4>

          <div className="form-flex-wrap">
            <div className="info-item justify-start row-align borderbottom-none" >
              <label>Financial Year:</label>

              <span>
                {regime_fy_start && regime_fy_end
                  ? `${new Date(regime_fy_start).getFullYear()}-${new Date(regime_fy_end).getFullYear()}`
                  : "-"
                }
              </span>

            </div>
            <div className="info-item justify-start row-align borderbottom-none">
              <label>Employee Code:</label>
              <span>{emp_code || "-"}</span>
            </div>
            <div className="info-item justify-start row-align borderbottom-none">
              <label>Name:</label>
              <span>{emp_name || "-"}</span>
            </div>


            <div className="info-item justify-start row-align borderbottom-none">
              <label>Age:</label>
              <span>{age || "-"} years</span>
            </div>
            <div className="info-item justify-start row-align borderbottom-none">
              <label>Tax Regime:</label>
              <span>{regime_name || regime || "-"}</span>
            </div>

          </div>
        </div>

        {/*--------------------------------------- INCOME DETAIL */}
        <div className="section-card">
          <h4 className="section-title">Income Detail</h4>

          <div className="calculation-grid">
            <div className="calculation-row relative">
              <span>Gross Monthly Salary:</span>
              <span className="amount" title={`${income_calculation_heading ? income_calculation_heading : ''} (${income_calculation_method})`} style={{ cursor: 'help' }}>
                ₹{monthly_gross_salary?.toLocaleString("en-IN") || "0"}
              </span>
            </div>

          </div>
        </div>

        <div className="section-card">
          <h4 className="section-title">Income Breakdown</h4>

          <div className="calculation-grid">
            <div className="calculation-row">
              <span>Gross Annual Salary:</span>
              <span className="amount">
                ₹{annual_gross_salary?.toLocaleString("en-IN") || "0"}
              </span>

            </div>

            <div className="calculation-row deduction">
              <span>Less: Standard Deduction:</span>
              <span className="amount">
                -₹{standard_deduction?.toLocaleString("en-IN") || "0"}
              </span>
            </div>

            <div className="calculation-row subtotal">
              <span>Gross Total Income from Salary:</span>
              <span className="amount">
                ₹
                {gross_total_income_from_salary?.toLocaleString("en-IN") ||
                  "0"}
              </span>
            </div>

            {/* --------------------------------------Other INcome */}
            <div className="calculation-row section-header">
              <span>Other Incomes:</span>
              {other_income_details?.length > 0 &&
                <span>
                  <ButtonVariants
                    buttonDisplay={'Eye'}
                    buttonDisplayName={'View Details'}
                    buttonDisplayTitle={'View Details related to Income'}
                    handleShow={handleShowIncomeDetails}
                  />
                </span>
              }
            </div>
            <div className="calculation-row income flex-column" style={{ gap: '5px' }}>
              {other_income_details?.length > 0 ?
                (
                  other_income_details.map((income, index) => (

                    <div key={index} className='calculation-row w-full' style={{ padding: '2px 0px' }}>
                      <span className="indented">
                        + {income.section_code}:
                      </span>
                      <span className="amount">
                        +₹
                        {income.declared_amount?.toLocaleString("en-IN") ||
                          "0"}
                      </span>
                    </div>

                  ))
                )
                :
                <div style={{ color: 'gray', marginLeft: '20px' }}>No other Income</div>
              }
            </div>

            <div className="calculation-row subtotal">
              <span>Total Income:</span>
              <span className="amount">
                ₹{totalOtherIncome?.toLocaleString(
                  "en-IN"
                ) || "0"}
              </span>
            </div>

            {/*---------------------------------- Other Investment */}
            <div className="calculation-row section-header">
              <span>Other Investment:</span>
              {other_investment_details?.length > 0 &&
                <span>
                  <ButtonVariants
                    buttonDisplay={'Eye'}
                    buttonDisplayName={'View Details'}
                    buttonDisplayTitle={'View Details related to Investment'}
                    handleShow={handleShowInvestDetails}
                  />
                </span>
              }
            </div>
            <div className="calculation-row deduction flex-column" style={{ gap: '5px' }}>
              {other_investment_details?.length > 0 ? (
                other_investment_details.map((inv, index) => (
                  <div key={index} className='calculation-row w-full' style={{ padding: '2px 0px' }}>
                    <span className="indented">
                      - {inv.section_code}:
                    </span>
                    <span className="amount">
                      -₹
                      {inv.declared_amount?.toLocaleString("en-IN") || "0"}
                    </span>
                  </div>
                ))
              )
                :
                <div style={{ color: 'gray', marginLeft: '20px' }}>No other Investment</div>
              }
            </div>
            <div className="calculation-row subtotal">
              <span>Total Investment:</span>
              <span className="amount">

                ₹{totalInvestmentsAllowed?.toLocaleString("en-IN") || "0"}
              </span>
            </div>

            <CustomTooltip
              position="top"
              tooltipContent={
                <div
                  style={{
                    padding: "12px",
                    fontSize: "13px",
                    lineHeight: "1.8",
                    minWidth: "260px",
                  }}
                >

                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>Gross Total Income from Salary</span>
                    &nbsp; &nbsp;
                    <strong>
                      ₹
                      {gross_total_income_from_salary?.toLocaleString("en-IN") || "0"}
                    </strong>
                  </div>


                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>+ Other Income</span>
                    <strong>
                      ₹
                      {totalOtherIncome?.toLocaleString("en-IN") ||
                        "0"}
                    </strong>
                  </div>


                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      color: "#dc3545",
                    }}
                  >
                    <span >- Other Investment</span>
                    <strong>
                      ₹{totalInvestmentsAllowed?.toLocaleString("en-IN") || "0"}
                    </strong>
                  </div>


                  <hr style={{ margin: "8px 0", borderTop: "1px solid #ccc" }} />


                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>= Taxable Income</span>
                    <strong style={{ color: "#1bae3d" }}>
                      ₹{taxable_declared?.toLocaleString("en-IN") || "0"}
                    </strong>
                  </div>
                </div>
              }
            >
              <div className="calculation-row total" style={{ cursor: 'help' }}>
                <span>Taxable Income:</span>
                <span className="amount" >
                  ₹{taxable_declared?.toLocaleString("en-IN") || "0"}
                </span>
              </div>
            </CustomTooltip>

          </div>
        </div>

        <div className='mb-2'>
          <h4 className="section-title padding-xx">Tax Calculation</h4>
        </div>

        {/* TAX CALCULATION */}
        <div className="section-card">
          {slab_breakdown?.length > 0 && (
            <div className="slabs-section">
              <h5>Tax Slab Breakdown:</h5>
              <table className="slabs-table">
                <thead>
                  <tr>
                    <th>Slab Range</th>
                    <th>Rate(%)</th>
                    <th>Income in Slab</th>
                    <th>Tax Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {slab_breakdown.map((slab, index) => {
                    const min = slab.min_income ? slab.min_income.toLocaleString('en-IN') : '0';
                    // const max = slab.max_income ? slab.max_income.toLocaleString('en-IN') : <span style={{ fontSize: "22px", fontWeight: "600" }}>∞</span>;
                    const taxTooltipText = `${slab.rate_percent}% of ₹${slab.taxable_amount?.toLocaleString("en-IN") || "0"} = ₹${slab.tax?.toLocaleString("en-IN") || "0"}`;
                    return (

                      <tr key={index} >
                        {/* <td>{min} - {max}</td> */}
                        <td>
                          {min} -{" "}
                          {slab.max_income ? (
                            slab.max_income.toLocaleString("en-IN")
                          ) : (
                            <span style={{ fontSize: "22px", fontWeight: "600" }}>∞</span>
                          )}
                        </td>

                        <td>{slab.rate_percent}%</td>

                        <td className="income-slab" style={{ cursor: 'help' }}>
                          <CustomTooltip
                            position="top"
                            tooltipContent={getSlabBreakdownText(
                              slab,
                              index,
                              slab_breakdown,
                              taxable_declared
                            )}
                            customStyle={{
                              zIndex: 9999,
                              position: "absolute",
                            }}

                          >
                            <span className="slab-amount hover-highlight">
                              ₹{slab.taxable_amount?.toLocaleString("en-IN") || "0"}
                            </span>

                          </CustomTooltip>
                        </td>



                        <td style={{ cursor: 'help' }}>
                          <CustomTooltip
                            position="top"
                            tooltipContent={taxTooltipText}
                            customStyle={{
                              zIndex: 9999,
                              position: "absolute",
                              padding: "20px 12px",
                            }}
                          >
                            <span>
                              ₹{slab.tax?.toLocaleString("en-IN") || "0"}
                            </span>
                          </CustomTooltip>
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="slab-total">
                    <td colSpan="2">
                      <strong>Total</strong>
                    </td>
                    <td>
                      <strong>
                        ₹
                        {slab_breakdown
                          .reduce(
                            (s, i) => s + (i.taxable_amount || 0),
                            0
                          )
                          .toLocaleString("en-IN")}
                      </strong>
                    </td>
                    <td>
                      <strong>
                        ₹{slab_breakdown
                          .reduce(
                            (s, i) => s + (i.tax || 0),
                            0
                          ).toLocaleString("en-IN")}
                      </strong>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          )}


          {/* Additional Components */}
          <div className="tax-components">
            <div className="calculation-row">
              <span>Tax Before Rebate & Cess:</span>
              <span className="amount">
                ₹{declared_slab_tax_raw?.toLocaleString("en-IN")}
              </span>
            </div>

            {/* {rebate_applied > 0 && ( */}
            <div className="calculation-row deduction" >
              <span title='Rebate u/s 87A' style={{ cursor: 'help' }}>Rebate</span>
              <span className="amount">
                -₹{rebate_applied?.toLocaleString("en-IN")}
              </span>
            </div>
            {/* )} */}

            {/* {surcharge_applied > 0 && ( */}
            <div className="calculation-row">
              <span>Surcharge:</span>
              <span className="amount">
                +₹{surcharge_amount_declared_adj?.toLocaleString("en-IN")}
              </span>
            </div>
            {/* )} */}

            {/* {cess_value > 0 && ( */}
            <div className="calculation-row">
              <span title='Health & Education Cess' style={{ cursor: 'help' }}>
                Cess ({cess_percent || 4}%):
              </span>
              <span className="amount">
                +₹{cess_amount_declared_adj?.toLocaleString("en-IN")}
              </span>
            </div>
            {/* )} */}

            <div className="flex-column gap-1">
              <div className="calculation-row total-tax">
                <span>
                  <strong>Total Annual Tax:</strong>
                </span>
                <span className="">
                  <strong>₹{annual_tax_declared?.toLocaleString("en-IN") || "0"}</strong>
                </span>
              </div>
              <div className="calculation-row total-tax">
                <span>
                  <strong>Total Monthly Tax:</strong>
                </span>
                <span className="">
                  <strong>₹{monthly_tds_12_declared?.toLocaleString("en-IN") || "0"}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* TDS SUMMARY */}
        <div className="section-card">
          <h4 className="section-title">TDS Summary</h4>

          <div className="tds-summary">

            <div className="tds-item">
              <label>Total Income from Salary:</label>
              <span className="amount">
                ₹{gross_total_income_from_salary?.toLocaleString("en-IN")}
              </span>
            </div>
            <div className="tds-item">
              <label>Total Other Incomes:</label>
              <span className="amount">
                ₹{totalOtherIncome?.toLocaleString("en-IN")}
              </span>
            </div>

            <div className="tds-item">
              <label>Total Other Investment:</label>
              <span className="amount">
                ₹{totalInvestmentsAllowed?.toLocaleString("en-IN")}
              </span>
            </div>


            {/* <div className="tds-item">
                  <label>Monthly TDS (Remaining Months):</label>
                  <span className="amount">
                    ₹{monthly_tds_remaining_declared?.toLocaleString("en-IN") || "0"}
                  </span>
                </div> */}

            <div className="tds-item">
              <label>Taxable Income:</label>
              <span className="amount">
                ₹{taxable_declared?.toLocaleString("en-IN")}
              </span>
            </div>
            <div className="tds-item">
              <label>Monthly TDS:</label>
              <span className="amount">
                ₹{monthly_tds_12_declared?.toLocaleString("en-IN") || "0"}
              </span>
            </div>
            <div className="tds-item">
              <label>Total Annual Tax:</label>
              <span className="amount">
                ₹{annual_tax_declared?.toLocaleString("en-IN")}
              </span>
            </div>


          </div>
        </div>

        {/* <div className='flex-row justify-start'>
          <h4 className="section-title padding-xx" style={{ borderBottom: 'none', marginBottom: '0px', paddingRight: '10px' }}> Other Details
      
          </h4>
          <ButtonVariants
            buttonDisplay={'Eye'}
            buttonDisplayName={'View Details'}
            buttonDisplayTitle={'View Details related to Income and Investment'}
            handleShow={handleOpenOtherDetails}
          />
        </div> */}
      </div>

      {/* -------------------------------show income details modal */}
      <Modal show={showIncomeDetails} onHide={handleCloseIncomeDetails} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>View Income Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Other Income DETAILS */}
          {other_income_details.length > 0 && (
            <div className="section-card-black">
              <h4 className="section-title">Income Details</h4>

              <table className="slabs-table">
                <thead>
                  <tr>
                    <th>Section</th>
                    <th>Declared Amount</th>
                    <th>Description</th>
                  </tr>
                </thead>

                <tbody>
                  {other_income_details.map((income, index) => (
                    <tr key={index}>
                      <td>{income.section_code}</td>
                      <td>
                        ₹
                        {income.declared_amount?.toLocaleString("en-IN") ||
                          "0"}
                      </td>
                      <td>
                        {income.section_desc || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
      </Modal>
      {/* -------------------------------investmmet details modal */}
      <Modal show={showInvestDetails} onHide={handleCloseInvestDetails} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>View Investment Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* INVESTMENT DETAILS */}
          {other_investment_details.length > 0 && (
            <div className="section-card-black">
              <h4 className="section-title">Investment Details</h4>

              <table className="slabs-table">
                <thead>
                  <tr>
                    <th>Section</th>
                    <th>Declared Amount</th>
                    <th>Max Limit</th>
                    <th>Description</th>
                  </tr>
                </thead>

                <tbody>
                  {other_investment_details.map((inv, index) => (
                    <tr key={index}>
                      <td>{inv.section_code}</td>
                      <td >
                        <CustomTooltip
                          position="top"
                          tooltipContent={renderDeclaredTooltip(inv)}
                        >
                          <span className="hover-highlight" style={{ cursor: "help", borderBottom: '0px', marginTop: '2px' }}>
                            {/* ₹{inv.allowed_declared?.toLocaleString("en-IN") || "0"} */}
                            ₹{inv.declared_amount_original?.toLocaleString("en-IN") || "0"}
                          </span>
                        </CustomTooltip>
                      </td>

                      {/* <td>
                          ₹
                          {inv.allowed_declared?.toLocaleString("en-IN") ||
                            "0"}
                        </td> */}
                      <td>
                        ₹
                        {inv.max_limit?.toLocaleString("en-IN") ||
                          "0"}
                      </td>
                      <td>{inv.section_desc || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
      </Modal>

    </>
  )
}

const InvestmentDeclarationTdsDataForTdsTable = ({ empDetails, currenttaxData, mode }) => {
  const [showInvestDetails, setShowInvestDetails] = useState(false);
  const [showIncomeDetails, setShowIncomeDetails] = useState(false);

  const handleShowInvestDetails = () => setShowInvestDetails(true);
  const handleShowIncomeDetails = () => setShowIncomeDetails(true);
  const handleCloseIncomeDetails = () => setShowIncomeDetails(false);

  const handleCloseInvestDetails = () => setShowInvestDetails(false);
  const declared = currenttaxData?.declared_tax_details;
  const proof =
    mode === "proof" ? currenttaxData?.proof_tax_details : null;



  const getValue = (key) =>
    proof?.[key] ?? declared?.[key] ?? null;

  const annual_gross_salary = getValue("annual_gross_salary");
  const monthly_gross_salary = getValue("monthly_gross_salary");
  const income_after_standard_deduction = getValue("income_after_standard_deduction");
  const taxable_amount = getValue("taxable_amount");

  const standard_deduction = getValue("standard_deduction");

  const annual_tax = getValue("annual_tax");

  const monthly_tds_final = getValue("monthly_tds_final");

  const slab_tax_raw = getValue("slab_tax_raw");
  const slab_breakdown = getValue("slab_breakdown");

  const cess_amount = getValue("cess_amount");
  const cess_percent = getValue("cess_percent");

  const surcharge_amount = getValue("surcharge_amount");
  const surcharge_amount_standard = getValue("surcharge_amount_standard");

  const rebate_applied = getValue("rebate_applied");
  const salary_type_used_for_calculation = getValue("salary_type_used_for_calculation");
  const gross_income_calculation_method = getValue("gross_income_calculation_method");
  const gross_income_calculation_heading = getValue("gross_income_calculation_heading");




  const {
    other_income_details,
    total_declared_income,
    total_proof_income,

  } = currenttaxData?.other_income_summary || {}

  const {
    other_investment_details
    ,
    total_declared_investment,
    total_proof_investment
  } = currenttaxData?.other_investment_summary || {}

  const arrearReq = currenttaxData?.calculation_tax_details?.
    arrear_details_summary?.annual_arrear_details || [];
  const natureType = arrearReq?.nature_type;


  const formattedDatesArray =
    arrearReq?.length > 0
      ? arrearReq.map(date => formatDateTime(date))
      : [];

  const truncatedDateList =
    formattedDatesArray.length > 3
      ? `${formattedDatesArray.slice(0, 3).join(", ")} ...`
      : formattedDatesArray.join(", ");

  const fullDateListTooltip = (
    <div className='font-size-text'>
      {formattedDatesArray.map((date, index) => (
        <div key={index}>{date}</div>
      ))}
    </div>
  );




  const getSlabBreakdownText = (slab, index, slab_breakdown, taxable_income) => {
    let remaining = taxable_income;


    for (let i = 0; i < index; i++) {
      remaining -= slab_breakdown[i].taxable_amount;
    }
    let rangeLimit;
    if (slab.max_income) {
      rangeLimit = slab.max_income - slab.min_income;
    } else {

      rangeLimit = remaining;
    }


    if (isNaN(rangeLimit)) rangeLimit = remaining;

    const usedAmount = slab.taxable_amount;
    const afterThis = remaining - usedAmount;

    return (
      <div style={{ padding: "10px", fontSize: "13px", minWidth: "260px" }}>

        <div style={{ marginTop: "8px" }}>
          <strong>Starting Balance:</strong><br />
          ₹{remaining?.toLocaleString("en-IN")}
        </div>

        <div style={{ marginTop: "8px" }}>
          <strong>Slab Deduction Limit:</strong><br />
          ₹{rangeLimit?.toLocaleString("en-IN")}
        </div>

        <div style={{ marginTop: "8px", color: "red" }}>
          <strong>Income Deducted in Slab:</strong><br />
          ₹{usedAmount?.toLocaleString("en-IN")}
        </div>

        <hr style={{ margin: "8px 0" }} />

        <div>
          <strong>Remaining After This Slab:</strong><br />
          ₹{afterThis?.toLocaleString("en-IN")}
        </div>
      </div>
    );
  };

  const renderDeclaredTooltip = (inv) => {
    return (
      <div
        style={{
          padding: "12px",
          fontSize: "13px",
          lineHeight: "1.8",
          minWidth: "260px",

        }}
      >

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Declared Amount</span>
          <strong>
            ₹{inv.declared_amount_original?.toLocaleString("en-IN") || "0"}
          </strong>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Max Limit</span>
          <strong>
            ₹{inv.max_limit?.toLocaleString("en-IN") || "0"}
          </strong>
        </div>


        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Allowed Amount</span>
          <strong style={{ color: "#1bae3d" }}>
            ₹{inv.allowed_declared?.toLocaleString("en-IN") || "0"}
          </strong>
        </div>
      </div>
    );
  };
  return (
    <>
      <div className="tds-calculation-container">
        {/* --------------------------------------BASIC INFO */}
        <div className="section-card">
          <h4 className="section-title">Basic Information</h4>
          <div className="form-flex-wrap">
            <div className="info-item justify-start row-align borderbottom-none">
              <label>Financial Year:</label>
              <span>
                {currenttaxData?.regime?.regime_fy_start &&
                  currenttaxData?.regime?.regime_fy_end
                  ? `${new Date(currenttaxData.regime.regime_fy_start).getFullYear()}-${new Date(currenttaxData.regime.regime_fy_end).getFullYear()}`
                  : "-"}
              </span>
            </div>

            <div className="info-item justify-start row-align borderbottom-none">
              <label>Employee Code:</label>
              <span>{empDetails?.emp_code || "-"}</span>
            </div>

            <div className="info-item justify-start row-align borderbottom-none">
              <label>Name:</label>
              <span>{empDetails?.emp_name || "-"}</span>
            </div>

            <div className="info-item justify-start row-align borderbottom-none">
              <label>Age:</label>
              <span>
                {currenttaxData?.age ? `${currenttaxData.age} years` : "-"}
              </span>
            </div>

            <div className="info-item justify-start row-align borderbottom-none">
              <label>Tax Regime:</label>
              <span>{currenttaxData?.regime?.name || "-"}</span>
            </div>
          </div>


        </div>

        {/*--------------------------------------- INCOME DETAIL */}

        <div className="section-card">
          <h4 className="section-title">Income Detail</h4>

          <div className="calculation-grid">
            <div className="calculation-row relative">
              <span>Gross Monthly Salary:</span>
              <span className="amount" title={`${gross_income_calculation_heading ? gross_income_calculation_heading : ''} (${gross_income_calculation_method})`} style={{ cursor: 'help' }}>
                ₹{monthly_gross_salary?.toLocaleString("en-IN") || "0"}
              </span>
            </div>

          </div>
        </div>

        <div className="section-card">
          <h4 className="section-title">Income Breakdown</h4>

          <div className="calculation-grid">
            <div className="calculation-row">
              <span>Gross Annual Salary:</span>
              <span className="amount">
                ₹{annual_gross_salary?.toLocaleString("en-IN") || "0"}
              </span>

            </div>


            <div className="calculation-row deduction">
              <span>Less: Standard Deduction:</span>
              <span className="amount">
                -₹{standard_deduction?.toLocaleString("en-IN") || "0"}
              </span>
            </div>

            <div className="calculation-row subtotal">
              <span>Gross Total Income from Salary:</span>
              <span className="amount">
                ₹
                {income_after_standard_deduction?.toLocaleString("en-IN") ||
                  "0"}
              </span>
            </div>

            {/* --------------------------------------Other INcome */}
            <div className="calculation-row section-header">
              <span>Other Incomes:</span>
              {other_income_details?.length > 0 &&
                <span>
                  <ButtonVariants
                    buttonDisplay={'Eye'}
                    buttonDisplayName={'View Details'}
                    buttonDisplayTitle={'View Details related to Income'}
                    handleShow={handleShowIncomeDetails}
                  />
                </span>
              }
            </div>
            <div className="calculation-row income flex-column" style={{ gap: '5px' }}>
              {other_income_details?.length > 0 ?
                (
                  other_income_details.map((income, index) => (

                    <div key={index} className='calculation-row w-full' style={{ padding: '2px 0px' }}>
                      <span className="indented">
                        + {income.section_code}:
                      </span>
                      <span className="amount">
                        +₹
                        {income.declared_amount?.toLocaleString("en-IN") ||
                          "0"}
                      </span>
                    </div>

                  ))
                )
                :
                <div style={{ color: 'gray', marginLeft: '20px' }}>No other Income</div>
              }
            </div>

            <div className="calculation-row subtotal">
              <span>Total Income:</span>
              <span className="amount">
                ₹{total_declared_income?.toLocaleString(
                  "en-IN"
                ) || "0"}
              </span>
            </div>

            {/*---------------------------------- Other Investment */}
            <div className="calculation-row section-header">
              <span>Other Investment:</span>
              {other_investment_details?.length > 0 &&
                <span>
                  <ButtonVariants
                    buttonDisplay={'Eye'}
                    buttonDisplayName={'View Details'}
                    buttonDisplayTitle={'View Details related to Investment'}
                    handleShow={handleShowInvestDetails}
                  />
                </span>
              }
            </div>
            <div className="calculation-row deduction flex-column" style={{ gap: '5px' }}>
              {other_investment_details?.length > 0 ? (
                other_investment_details.map((inv, index) => (
                  <div key={index} className='calculation-row w-full' style={{ padding: '2px 0px' }}>
                    <span className="indented">
                      - {inv.section_code}:
                    </span>
                    <span className="amount">
                      -₹
                      {inv.declared_amount?.toLocaleString("en-IN") || "0"}
                    </span>
                  </div>
                ))
              )
                :
                <div style={{ color: 'gray', marginLeft: '20px' }}>No other Investment</div>
              }
            </div>
            <div className="calculation-row subtotal">
              <span>Total Investment:</span>
              <span className="amount">

                ₹{total_declared_investment?.toLocaleString("en-IN") || "0"}
              </span>
            </div>

            <CustomTooltip
              position="top"
              tooltipContent={
                <div
                  style={{
                    padding: "12px",
                    fontSize: "13px",
                    lineHeight: "1.8",
                    minWidth: "260px",
                  }}
                >

                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>Gross Total Income from Salary</span>
                    &nbsp; &nbsp;
                    <strong>
                      ₹
                      {income_after_standard_deduction?.toLocaleString("en-IN") || "0"}
                    </strong>
                  </div>


                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>+ Other Income</span>
                    <strong>
                      ₹
                      {total_declared_income?.toLocaleString("en-IN") ||
                        "0"}
                    </strong>
                  </div>


                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      color: "#dc3545",
                    }}
                  >
                    <span >- Other Investment</span>
                    <strong>
                      ₹{total_declared_investment?.toLocaleString("en-IN") || "0"}
                    </strong>
                  </div>


                  <hr style={{ margin: "8px 0", borderTop: "1px solid #ccc" }} />


                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span>= Taxable Income</span>
                    <strong style={{ color: "#1bae3d" }}>
                      ₹{taxable_amount?.toLocaleString("en-IN") || "0"}
                    </strong>
                  </div>
                </div>
              }
            >
              <div className="calculation-row total" style={{ cursor: 'help' }}>
                <span>Taxable Income:</span>
                <span className="amount" >
                  ₹{taxable_amount?.toLocaleString("en-IN") || "0"}
                </span>
              </div>
            </CustomTooltip>

          </div>
        </div>

        <div className='mb-2'>
          <h4 className="section-title padding-xx">Tax Calculation</h4>
        </div>


        {/* TAX CALCULATION */}
        <div className="section-card">
          {slab_breakdown?.length > 0 && (
            <div className="slabs-section">
              <h5>Tax Slab Breakdown:</h5>
              <table className="slabs-table">
                <thead>
                  <tr>
                    <th>Slab Range</th>
                    <th>Rate(%)</th>
                    <th>Income in Slab</th>
                    <th>Tax Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {slab_breakdown.map((slab, index) => {
                    const min = slab.min_income ? slab.min_income.toLocaleString('en-IN') : '0';
                    // const max = slab.max_income ? slab.max_income.toLocaleString('en-IN') : <span style={{ fontSize: "22px", fontWeight: "600" }}>∞</span>;
                    const taxTooltipText = `${slab.rate_percent}% of ₹${slab.taxable_amount?.toLocaleString("en-IN") || "0"} = ₹${slab.tax?.toLocaleString("en-IN") || "0"}`;
                    return (

                      <tr key={index} >
                        {/* <td>{min} - {max}</td> */}
                        <td>
                          {min} -{" "}
                          {slab.max_income ? (
                            slab.max_income.toLocaleString("en-IN")
                          ) : (
                            <span style={{ fontSize: "22px", fontWeight: "600" }}>∞</span>
                          )}
                        </td>

                        <td>{slab.rate_percent}%</td>

                        <td className="income-slab" style={{ cursor: 'help' }}>
                          <CustomTooltip
                            position="top"
                            tooltipContent={getSlabBreakdownText(
                              slab,
                              index,
                              slab_breakdown,
                              taxable_amount
                            )}
                          // customStyle={{
                          //   zIndex: 9999,
                          //   position: "absolute",
                          // }}

                          >
                            <span className="slab-amount hover-highlight">
                              ₹{slab.taxable_amount?.toLocaleString("en-IN") || "0"}
                            </span>

                          </CustomTooltip>
                        </td>



                        <td style={{ cursor: 'help' }}>
                          <CustomTooltip
                            position="top"
                            tooltipContent={taxTooltipText}
                            customStyle={{
                              zIndex: 9999,
                              position: "absolute",
                              padding: "20px 12px",
                            }}
                          >
                            <span>
                              ₹{slab.tax?.toLocaleString("en-IN") || "0"}
                            </span>
                          </CustomTooltip>
                        </td>
                      </tr>
                    );
                  })}
                  <tr className="slab-total">
                    <td colSpan="2">
                      <strong>Total</strong>
                    </td>
                    <td>
                      <strong>
                        ₹
                        {slab_breakdown
                          .reduce(
                            (s, i) => s + (i.taxable_amount || 0),
                            0
                          )
                          .toLocaleString("en-IN")}
                      </strong>
                    </td>
                    <td>
                      <strong>
                        ₹{slab_breakdown
                          .reduce(
                            (s, i) => s + (i.tax || 0),
                            0
                          ).toLocaleString("en-IN")}
                      </strong>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          )}


          {/* Additional Components */}
          <div className="tax-components">
            <div className="calculation-row">
              <span>Tax Before Rebate & Cess:</span>
              <span className="amount">
                ₹{slab_tax_raw?.toLocaleString("en-IN")}
              </span>
            </div>

            {/* {rebate_applied > 0 && ( */}
            <div className="calculation-row deduction" >
              <span title='Rebate u/s 87A' style={{ cursor: 'help' }}>Rebate</span>
              <span className="amount">
                -₹{rebate_applied?.toLocaleString("en-IN")}
              </span>
            </div>
            {/* )} */}

            {/* {surcharge_applied > 0 && ( */}
            <div className="calculation-row">
              <span>Surcharge:</span>
              <span className="amount">
                +₹{surcharge_amount?.toLocaleString("en-IN")}
              </span>
            </div>
            {/* )} */}

            {/* {cess_value > 0 && ( */}
            <div className="calculation-row">
              <span title='Health & Education Cess' style={{ cursor: 'help' }}>
                Cess ({cess_percent || 4}%):
              </span>
              <span className="amount">
                +₹{cess_amount?.toLocaleString("en-IN")}
              </span>
            </div>
            {/* )} */}

            <div className="flex-column gap-1">
              <div className="calculation-row total-tax">
                <span>
                  <strong>Total Annual Tax:</strong>
                </span>
                <span className="">
                  <strong>₹{annual_tax?.toLocaleString("en-IN") || "0"}</strong>
                </span>
              </div>
              <div className="calculation-row total-tax">
                <span>
                  <strong>Total Monthly Tax:</strong>
                </span>
                <span className="">
                  <strong>₹{monthly_tds_final?.toLocaleString("en-IN") || "0"}</strong>
                </span>
              </div>
            </div>
          </div>
        </div>


        {/* TDS SUMMARY */}
        <div className="section-card">
          <h4 className="section-title">TDS Summary</h4>

          <div className="tds-summary">

            <div className="tds-item">
              <label>Total Income from Salary:</label>
              <span className="amount">
                ₹{income_after_standard_deduction?.toLocaleString("en-IN")}
              </span>
            </div>
            <div className="tds-item">
              <label>Total Other Incomes:</label>
              <span className="amount">
                ₹{total_declared_income?.toLocaleString("en-IN")}
              </span>
            </div>

            <div className="tds-item">
              <label>Total Other Investment:</label>
              <span className="amount">
                ₹{total_declared_investment?.toLocaleString("en-IN")}
              </span>
            </div>


            {/* <div className="tds-item">
                  <label>Monthly TDS (Remaining Months):</label>
                  <span className="amount">
                    ₹{monthly_tds_remaining_declared?.toLocaleString("en-IN") || "0"}
                  </span>
                </div> */}

            <div className="tds-item">
              <label>Taxable Income:</label>
              <span className="amount">
                ₹{taxable_amount?.toLocaleString("en-IN")}
              </span>
            </div>
            <div className="tds-item">
              <label>Monthly TDS:</label>
              <span className="amount">
                ₹{monthly_tds_final?.toLocaleString("en-IN") || "0"}
              </span>
            </div>
            <div className="tds-item">
              <label>Total Annual Tax:</label>
              <span className="amount">
                ₹{annual_tax?.toLocaleString("en-IN")}
              </span>
            </div>


          </div>
        </div>



        {/* <div className='flex-row justify-start'>
          <h4 className="section-title padding-xx" style={{ borderBottom: 'none', marginBottom: '0px', paddingRight: '10px' }}> Other Details
           
          </h4>
          <ButtonVariants
            buttonDisplay={'Eye'}
            buttonDisplayName={'View Details'}
            buttonDisplayTitle={'View Details related to Income and Investment'}
            handleShow={handleOpenOtherDetails}
          />
        </div> */}

      </div>


      {/* -------------------------------show income details modal */}
      <Modal show={showIncomeDetails} onHide={handleCloseIncomeDetails} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>View Income Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Other Income DETAILS */}
          {other_income_details.length > 0 && (
            <div className="section-card-black">
              <h4 className="section-title">Income Details</h4>

              <table className="slabs-table">
                <thead>
                  <tr>
                    <th>Section</th>
                    <th>Declared Amount</th>
                    <th>Description</th>
                  </tr>
                </thead>

                <tbody>
                  {other_income_details.map((income, index) => (
                    <tr key={index}>
                      <td>{income.section_code}</td>
                      <td>
                        ₹
                        {income.declared_amount?.toLocaleString("en-IN") ||
                          "0"}
                      </td>
                      <td>
                        {income.section_desc || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
      </Modal>
      {/* -------------------------------investmmet details modal */}
      <Modal show={showInvestDetails} onHide={handleCloseInvestDetails} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>View Investment Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* INVESTMENT DETAILS */}
          {other_investment_details.length > 0 && (
            <div className="section-card-black">
              <h4 className="section-title">Investment Details</h4>

              <table className="slabs-table">
                <thead>
                  <tr>
                    <th>Section</th>
                    <th>Declared Amount</th>
                    <th>Max Limit</th>
                    <th>Description</th>
                  </tr>
                </thead>

                <tbody>
                  {other_investment_details.map((inv, index) => (
                    <tr key={index}>
                      <td>{inv.section_code}</td>
                      <td >
                        <CustomTooltip
                          position="top"
                          tooltipContent={renderDeclaredTooltip(inv)}
                        >
                          <span className="hover-highlight" style={{ cursor: "help", borderBottom: '0px', marginTop: '2px' }}>
                            {/* ₹{inv.allowed_declared?.toLocaleString("en-IN") || "0"} */}
                            ₹{inv.declared_amount_original?.toLocaleString("en-IN") || "0"}
                          </span>
                        </CustomTooltip>
                      </td>

                      {/* <td>
                          ₹
                          {inv.allowed_declared?.toLocaleString("en-IN") ||
                            "0"}
                        </td> */}
                      <td>
                        ₹
                        {inv.max_limit?.toLocaleString("en-IN") ||
                          "0"}
                      </td>
                      <td>{inv.section_desc || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
      </Modal>

    </>
  )
}
// const InvestmentProofTdsDataForTdsTable = ({ empDetails, currenttaxData }) => {



//   const arrearReq = arrear_details?.arrear_request_details?.request_details;
//   const natureType = arrearReq?.nature_type;


//   const formattedDatesArray =
//     arrearReq?.date_list?.length > 0
//       ? arrearReq.date_list.map(date => formatDateTime(date))
//       : [];

//   const truncatedDateList =
//     formattedDatesArray.length > 3
//       ? `${formattedDatesArray.slice(0, 3).join(", ")} ...`
//       : formattedDatesArray.join(", ");

//   const fullDateListTooltip = (
//     <div className='font-size-text'>
//       {formattedDatesArray.map((date, index) => (
//         <div key={index}>{date}</div>
//       ))}
//     </div>
//   );


//   const totalOtherIncome =
//     other_income_details?.reduce(
//       (sum, income) => sum + (income.declared_amount || 0),
//       0
//     ) || 0;

//   const totalInvestmentsAllowed =
//     other_investment_details?.reduce(
//       (sum, d) => sum + (d.amount_allowed || 0),
//       0
//     ) || 0;

//   const totalSlabTax =
//     slabs?.reduce((sum, slab) => sum + (slab.slab_tax_amount || 0), 0) || 0;



//   const getSlabBreakdownText = (slab, index, slab_breakdown, taxable_income) => {
//     let remaining = taxable_income;


//     for (let i = 0; i < index; i++) {
//       remaining -= slab_breakdown[i].taxable_amount;
//     }
//     let rangeLimit;
//     if (slab.max_income) {
//       rangeLimit = slab.max_income - slab.min_income;
//     } else {

//       rangeLimit = remaining;
//     }


//     if (isNaN(rangeLimit)) rangeLimit = remaining;
//     // const rangeLimit = slab.max_income ? slab.max_income - slab.min_income : remaining || 0;

//     const usedAmount = slab.taxable_amount;
//     const afterThis = remaining - usedAmount;

//     return (
//       <div style={{ padding: "10px", fontSize: "13px", minWidth: "260px" }}>
//         {/* <div><strong>Slab Range:</strong> {slab.min_income.toLocaleString("en-IN")} - {slab.max_income ? slab.max_income.toLocaleString("en-IN") : "∞"}</div> */}

//         <div style={{ marginTop: "8px" }}>
//           <strong>Starting Balance:</strong><br />
//           ₹{remaining?.toLocaleString("en-IN")}
//         </div>

//         <div style={{ marginTop: "8px" }}>
//           <strong>Slab Deduction Limit:</strong><br />
//           ₹{rangeLimit?.toLocaleString("en-IN")}
//         </div>

//         <div style={{ marginTop: "8px", color: "red" }}>
//           <strong>Income Deducted in Slab:</strong><br />
//           ₹{usedAmount?.toLocaleString("en-IN")}
//         </div>

//         <hr style={{ margin: "8px 0" }} />

//         <div>
//           <strong>Remaining After This Slab:</strong><br />
//           ₹{afterThis?.toLocaleString("en-IN")}
//         </div>
//       </div>
//     );
//   };

//   const renderDeclaredTooltip = (inv) => {
//     return (
//       <div
//         style={{
//           padding: "12px",
//           fontSize: "13px",
//           lineHeight: "1.8",
//           minWidth: "260px",

//         }}
//       >

//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <span>Declared Amount</span>
//           <strong>
//             ₹{inv.declared_amount_original?.toLocaleString("en-IN") || "0"}
//           </strong>
//         </div>

//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <span>Max Limit</span>
//           <strong>
//             ₹{inv.max_limit?.toLocaleString("en-IN") || "0"}
//           </strong>
//         </div>


//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <span>Allowed Amount</span>
//           <strong style={{ color: "#1bae3d" }}>
//             ₹{inv.allowed_declared?.toLocaleString("en-IN") || "0"}
//           </strong>
//         </div>
//       </div>
//     );
//   };
//   return (
//     <>
//       <div className="tds-calculation-container">
//         {/* --------------------------------------BASIC INFO */}
//         {/* <div className="section-card">
//           <h4 className="section-title">Basic Information</h4>

//           <div className="form-flex-wrap">
//             <div className="info-item justify-start row-align borderbottom-none" >
//               <label>Financial Year:</label>

//               <span>
//                 {regime_fy_start && regime_fy_end
//                   ? `${new Date(regime_fy_start).getFullYear()}-${new Date(regime_fy_end).getFullYear()}`
//                   : "-"
//                 }
//               </span>

//             </div>
//             <div className="info-item justify-start row-align borderbottom-none">
//               <label>Employee Code:</label>
//               <span>{emp_code || "-"}</span>
//             </div>
//             <div className="info-item justify-start row-align borderbottom-none">
//               <label>Name:</label>
//               <span>{emp_name || "-"}</span>
//             </div>


//             <div className="info-item justify-start row-align borderbottom-none">
//               <label>Age:</label>
//               <span>{age || "-"} years</span>
//             </div>
//             <div className="info-item justify-start row-align borderbottom-none">
//               <label>Tax Regime:</label>
//               <span>{regime_name || regime || "-"}</span>
//             </div>

//           </div>
//         </div> */}

//         {/*--------------------------------------- INCOME DETAIL */}
//         <div className="section-card">
//           <h4 className="section-title">Income Detail</h4>

//           <div className="calculation-grid">
//             <div className="calculation-row relative">
//               <span>Gross Monthly Salary:</span>
//               <span className="amount" title={`${income_calculation_heading} (${income_calculation_method})`} style={{ cursor: 'help' }}>
//                 ₹{monthly_gross_salary?.toLocaleString("en-IN") || "0"}
//               </span>
//             </div>

//           </div>
//         </div>

//         <div className="section-card">
//           <h4 className="section-title">Income Breakdown</h4>

//           <div className="calculation-grid">
//             <div className="calculation-row">
//               <span>Gross Annual Salary:</span>
//               <span className="amount">
//                 ₹{annual_gross_salary?.toLocaleString("en-IN") || "0"}
//               </span>

//             </div>
//             {/* -------------------------------------arrear details */}
//             {arrear_details && (
//               <>
//                 <div className="">
//                   <h4 className="section-title">Arrear Summary</h4>

//                   <div className="tds-summary">
//                     <div className="tds-item">
//                       <label className="text-capitalize">{`${arrear_details?.arrear_request_details?.request_details?.nature_name} (${natureType})`} :</label>

//                       <span className="amount text-capitalize">
//                         {natureType === "days" && (
//                           formattedDatesArray.length > 3 ? (
//                             <CustomTooltip
//                               position="top"
//                               tooltipContent={fullDateListTooltip}
//                             >
//                               <span style={{ cursor: "help", textDecoration: "underline dotted" }}>
//                                 {truncatedDateList}
//                               </span>
//                             </CustomTooltip>
//                           ) : (
//                             truncatedDateList || "-"
//                           )
//                         )}

//                         {natureType === "months" && (
//                           <>
//                             {formatDate(arrearReq?.start_date)} to{" "}
//                             {formatDate(arrearReq?.end_date)}
//                           </>
//                         )}

//                         {natureType === "amount" && (
//                           <span className="font-weight600">
//                             ₹{arrearReq?.approved_amount?.toLocaleString("en-IN") || 0}
//                           </span>
//                         )}
//                       </span>
//                     </div>

//                     <div className="tds-item">
//                       <label>{(arrear_details?.arrear_tax_details?.total_days) !== 0 ? 'Approved Days:' : 'Approved Amount'}</label>
//                       <span className="amount font-weight600">
//                         {arrear_details?.arrear_tax_details?.total_days !== 0
//                           ? `${arrear_details?.arrear_tax_details?.total_days?.toLocaleString("en-IN") || 0} days`
//                           : arrear_details?.arrear_tax_details?.total_amount?.toLocaleString("en-IN") || 0}
//                       </span>

//                     </div>



//                   </div>
//                 </div>


//                 <div className="calculation-row">
//                   <span>Total Arrear Amount:</span>
//                   <span className="amount">
//                     ₹
//                     {arrear_details?.arrear_tax_details?.total_arrear_amount?.toLocaleString("en-IN") || 0}
//                   </span>
//                 </div>
//               </>
//             )}

//             <div className="calculation-row deduction">
//               <span>Less: Standard Deduction:</span>
//               <span className="amount">
//                 -₹{standard_deduction?.toLocaleString("en-IN") || "0"}
//               </span>
//             </div>

//             <div className="calculation-row subtotal">
//               <span>Gross Total Income from Salary:</span>
//               <span className="amount">
//                 ₹
//                 {gross_total_income_from_salary?.toLocaleString("en-IN") ||
//                   "0"}
//               </span>
//             </div>

//             {/* --------------------------------------Other INcome */}
//             <div className="calculation-row section-header">
//               <span>Other Incomes:</span>
//             </div>
//             <div className="calculation-row income flex-column" style={{ gap: '5px' }}>
//               {other_income_details?.length > 0 ?
//                 (
//                   other_income_details.map((income, index) => (

//                     <div key={index} className='calculation-row w-full' style={{ padding: '2px 0px' }}>
//                       <span className="indented">
//                         + {income.section_code}:
//                       </span>
//                       <span className="amount">
//                         +₹
//                         {income.declared_amount?.toLocaleString("en-IN") ||
//                           "0"}
//                       </span>
//                     </div>

//                   ))
//                 )
//                 :
//                 <div style={{ color: 'gray', marginLeft: '20px' }}>No other Income</div>
//               }
//             </div>

//             <div className="calculation-row subtotal">
//               <span>Total Income:</span>
//               <span className="amount">
//                 ₹{total_declared_income?.toLocaleString(
//                   "en-IN"
//                 ) || "0"}
//               </span>
//             </div>

//             {/*---------------------------------- Other Investment */}
//             <div className="calculation-row section-header">
//               <span>Other Investment:</span>
//             </div>
//             <div className="calculation-row deduction flex-column" style={{ gap: '5px' }}>
//               {other_investment_details?.length > 0 ? (
//                 other_investment_details.map((inv, index) => (
//                   <div key={index} className='calculation-row w-full' style={{ padding: '2px 0px' }}>
//                     <span className="indented">
//                       - {inv.section_code}:
//                     </span>
//                     <span className="amount">
//                       -₹
//                       {inv.declared_amount?.toLocaleString("en-IN") || "0"}
//                     </span>
//                   </div>
//                 ))
//               )
//                 :
//                 <div style={{ color: 'gray', marginLeft: '20px' }}>No other Investment</div>
//               }
//             </div>
//             <div className="calculation-row subtotal">
//               <span>Total Investment:</span>
//               <span className="amount">

//                 ₹{total_declared_investment?.toLocaleString("en-IN") || "0"}
//               </span>
//             </div>

//             <CustomTooltip
//               position="top"
//               tooltipContent={
//                 <div
//                   style={{
//                     padding: "12px",
//                     fontSize: "13px",
//                     lineHeight: "1.8",
//                     minWidth: "260px",
//                   }}
//                 >

//                   <div style={{ display: "flex", justifyContent: "space-between" }}>
//                     <span>Gross Total Income from Salary</span>
//                     &nbsp; &nbsp;
//                     <strong>
//                       ₹
//                       {gross_total_income_from_salary?.toLocaleString("en-IN") || "0"}
//                     </strong>
//                   </div>


//                   <div style={{ display: "flex", justifyContent: "space-between" }}>
//                     <span>+ Other Income</span>
//                     <strong>
//                       ₹
//                       {total_declared_income?.toLocaleString("en-IN") ||
//                         "0"}
//                     </strong>
//                   </div>


//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       color: "#dc3545",
//                     }}
//                   >
//                     <span >- Other Investment</span>
//                     <strong>
//                       ₹{total_declared_investment?.toLocaleString("en-IN") || "0"}
//                     </strong>
//                   </div>


//                   <hr style={{ margin: "8px 0", borderTop: "1px solid #ccc" }} />


//                   <div style={{ display: "flex", justifyContent: "space-between" }}>
//                     <span>= Taxable Income</span>
//                     <strong style={{ color: "#1bae3d" }}>
//                       ₹{taxable_declared?.toLocaleString("en-IN") || "0"}
//                     </strong>
//                   </div>
//                 </div>
//               }
//             >
//               <div className="calculation-row total" style={{ cursor: 'help' }}>
//                 <span>Taxable Income:</span>
//                 <span className="amount" >
//                   ₹{taxable_declared?.toLocaleString("en-IN") || "0"}
//                 </span>
//               </div>
//             </CustomTooltip>

//           </div>
//         </div>

//         <div className='mb-2'>
//           <h4 className="section-title padding-xx">Tax Calculation</h4>
//         </div>

//         {/* TAX CALCULATION */}
//         <div className="section-card">
//           {slab_breakdown?.length > 0 && (
//             <div className="slabs-section">
//               <h5>Tax Slab Breakdown:</h5>
//               <table className="slabs-table">
//                 <thead>
//                   <tr>
//                     <th>Slab Range</th>
//                     <th>Rate(%)</th>
//                     <th>Income in Slab</th>
//                     <th>Tax Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {slab_breakdown.map((slab, index) => {
//                     const min = slab.min_income ? slab.min_income.toLocaleString('en-IN') : '0';
//                     // const max = slab.max_income ? slab.max_income.toLocaleString('en-IN') : <span style={{ fontSize: "22px", fontWeight: "600" }}>∞</span>;
//                     const taxTooltipText = `${slab.rate_percent}% of ₹${slab.taxable_amount?.toLocaleString("en-IN") || "0"} = ₹${slab.tax?.toLocaleString("en-IN") || "0"}`;
//                     return (

//                       <tr key={index} >
//                         {/* <td>{min} - {max}</td> */}
//                         <td>
//                           {min} -{" "}
//                           {slab.max_income ? (
//                             slab.max_income.toLocaleString("en-IN")
//                           ) : (
//                             <span style={{ fontSize: "22px", fontWeight: "600" }}>∞</span>
//                           )}
//                         </td>

//                         <td>{slab.rate_percent}%</td>

//                         <td className="income-slab" style={{ cursor: 'help' }}>
//                           <CustomTooltip
//                             position="top"
//                             tooltipContent={getSlabBreakdownText(
//                               slab,
//                               index,
//                               slab_breakdown,
//                               taxable_declared
//                             )}
//                             customStyle={{
//                               zIndex: 9999,
//                               position: "absolute",
//                             }}

//                           >
//                             <span className="slab-amount hover-highlight">
//                               ₹{slab.taxable_amount?.toLocaleString("en-IN") || "0"}
//                             </span>

//                           </CustomTooltip>
//                         </td>



//                         <td style={{ cursor: 'help' }}>
//                           <CustomTooltip
//                             position="top"
//                             tooltipContent={taxTooltipText}
//                             customStyle={{
//                               zIndex: 9999,
//                               position: "absolute",
//                               padding: "20px 12px",
//                             }}
//                           >
//                             <span>
//                               ₹{slab.tax?.toLocaleString("en-IN") || "0"}
//                             </span>
//                           </CustomTooltip>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                   <tr className="slab-total">
//                     <td colSpan="2">
//                       <strong>Total</strong>
//                     </td>
//                     <td>
//                       <strong>
//                         ₹
//                         {slab_breakdown
//                           .reduce(
//                             (s, i) => s + (i.taxable_amount || 0),
//                             0
//                           )
//                           .toLocaleString("en-IN")}
//                       </strong>
//                     </td>
//                     <td>
//                       <strong>
//                         ₹{slab_breakdown
//                           .reduce(
//                             (s, i) => s + (i.tax || 0),
//                             0
//                           ).toLocaleString("en-IN")}
//                       </strong>
//                     </td>
//                   </tr>

//                 </tbody>
//               </table>
//             </div>
//           )}


//           {/* Additional Components */}
//           <div className="tax-components">
//             <div className="calculation-row">
//               <span>Tax Before Rebate & Cess:</span>
//               <span className="amount">
//                 ₹{declared_slab_tax_raw?.toLocaleString("en-IN")}
//               </span>
//             </div>

//             {/* {rebate_applied > 0 && ( */}
//             <div className="calculation-row deduction" >
//               <span title='Rebate u/s 87A' style={{ cursor: 'help' }}>Rebate</span>
//               <span className="amount">
//                 -₹{rebate_applied?.toLocaleString("en-IN")}
//               </span>
//             </div>
//             {/* )} */}

//             {/* {surcharge_applied > 0 && ( */}
//             <div className="calculation-row">
//               <span>Surcharge:</span>
//               <span className="amount">
//                 +₹{surcharge_amount_declared_adj?.toLocaleString("en-IN")}
//               </span>
//             </div>
//             {/* )} */}

//             {/* {cess_value > 0 && ( */}
//             <div className="calculation-row">
//               <span title='Health & Education Cess' style={{ cursor: 'help' }}>
//                 Cess ({cess_percent || 4}%):
//               </span>
//               <span className="amount">
//                 +₹{cess_amount_declared_adj?.toLocaleString("en-IN")}
//               </span>
//             </div>
//             {/* )} */}

//             <div className="flex-column gap-1">
//               <div className="calculation-row total-tax">
//                 <span>
//                   <strong>Total Annual Tax:</strong>
//                 </span>
//                 <span className="">
//                   <strong>₹{annual_tax_declared?.toLocaleString("en-IN") || "0"}</strong>
//                 </span>
//               </div>
//               <div className="calculation-row total-tax">
//                 <span>
//                   <strong>Total Monthly Tax:</strong>
//                 </span>
//                 <span className="">
//                   <strong>₹{monthly_tds_12_declared?.toLocaleString("en-IN") || "0"}</strong>
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* TDS SUMMARY */}
//         <div className="section-card">
//           <h4 className="section-title">TDS Summary</h4>

//           <div className="tds-summary">

//             <div className="tds-item">
//               <label>Total Income from Salary:</label>
//               <span className="amount">
//                 ₹{gross_total_income_from_salary?.toLocaleString("en-IN")}
//               </span>
//             </div>
//             <div className="tds-item">
//               <label>Total Other Incomes:</label>
//               <span className="amount">
//                 ₹{total_declared_income?.toLocaleString("en-IN")}
//               </span>
//             </div>

//             <div className="tds-item">
//               <label>Total Other Investment:</label>
//               <span className="amount">
//                 ₹{total_declared_investment?.toLocaleString("en-IN")}
//               </span>
//             </div>


//             {/* <div className="tds-item">
//                   <label>Monthly TDS (Remaining Months):</label>
//                   <span className="amount">
//                     ₹{monthly_tds_remaining_declared?.toLocaleString("en-IN") || "0"}
//                   </span>
//                 </div> */}

//             <div className="tds-item">
//               <label>Taxable Income:</label>
//               <span className="amount">
//                 ₹{taxable_declared?.toLocaleString("en-IN")}
//               </span>
//             </div>
//             <div className="tds-item">
//               <label>Monthly TDS:</label>
//               <span className="amount">
//                 ₹{monthly_tds_12_declared?.toLocaleString("en-IN") || "0"}
//               </span>
//             </div>
//             <div className="tds-item">
//               <label>Total Annual Tax:</label>
//               <span className="amount">
//                 ₹{annual_tax_declared?.toLocaleString("en-IN")}
//               </span>
//             </div>


//           </div>
//         </div>

//         <div className='flex-row'>
//           <h4 className="section-title padding-xx w-full"> Other Details
//             {" "}
//             <InfoIcon />
//           </h4>
//         </div>

//         {/* Other Income DETAILS */}
//         {other_income_details.length > 0 && (
//           <div className="section-card-black">
//             <h4 className="section-title">Other Income Details</h4>

//             <table className="slabs-table">
//               <thead>
//                 <tr>
//                   <th>Section</th>
//                   <th>Declared Amount</th>
//                   <th>Description</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {other_income_details.map((income, index) => (
//                   <tr key={index}>
//                     <td>{income.section_code}</td>
//                     <td>
//                       ₹
//                       {income.declared_amount?.toLocaleString("en-IN") ||
//                         "0"}
//                     </td>
//                     <td>
//                       {income.section_desc || "-"}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {/* INVESTMENT DETAILS */}
//         {other_investment_details.length > 0 && (
//           <div className="section-card-black">
//             <h4 className="section-title">Investment Details</h4>

//             <table className="slabs-table">
//               <thead>
//                 <tr>
//                   <th>Section</th>
//                   <th>Declared Amount</th>
//                   <th>Max Limit</th>
//                   <th>Description</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {other_investment_details.map((inv, index) => (
//                   <tr key={index}>
//                     <td>{inv.section_code}</td>
//                     <td >
//                       <CustomTooltip
//                         position="top"
//                         tooltipContent={renderDeclaredTooltip(inv)}
//                       >
//                         <td className="hover-highlight" style={{ cursor: "help", borderBottom: '0px', marginTop: '2px' }}>
//                           {/* ₹{inv.allowed_declared?.toLocaleString("en-IN") || "0"} */}
//                           ₹{inv.declared_amount_original?.toLocaleString("en-IN") || "0"}
//                         </td>
//                       </CustomTooltip>
//                     </td>

//                     {/* <td>
//                           ₹
//                           {inv.allowed_declared?.toLocaleString("en-IN") ||
//                             "0"}
//                         </td> */}
//                     <td>
//                       ₹
//                       {inv.max_limit?.toLocaleString("en-IN") ||
//                         "0"}
//                     </td>
//                     <td>{inv.section_desc || "-"}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>
//     </>
//   )
// }
export {
  PaymentDashboard, UploadIncrementDataBulk,
  //  DownloadIncrementBulkFormat, 
  EditIncrementData, TdsCalculationModal
  , TdsCalculationModalForTDS, InvestmentDeclarationTdsDataForTdsTable,
};